
import envConfig from './env.js';
//const httpUrl = 'http://192.168.4.187:8080/huapin'
//const httpUrl = 'http://127.0.0.1:8080/huapin'
const httpUrl =envConfig.BASE_API;
//const httpUrl = 'https://bcqx.zhuzhux.com/huapin'


const globalServices = {
    httpUrl:httpUrl,
    //登录
    login: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/login`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/login',
    },
    vehicleMapWatch: {
        method: 'post',
        url: `${httpUrl}/deviceGpsInfo/list`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/login',
    },

    lastPoint: {
        method: 'post',
        url: `${httpUrl}/deviceGpsInfo/lastPoint`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/login',
    },

    

    logout: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/logout`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/logout',
    },
    // 获取登录信息
    queryResource: {
        method: 'get',
        url: `${httpUrl}/system/sysUser/getLoginUser`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/getLoginUser',
    },
    // 用户管理（账号管理）
    accountList: {
        method: 'get',
        url: `${httpUrl}/system/sysUser/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/getPageList',
    },
    accountAdd: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/add`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/add',
    },
    accountEdit: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/update`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/update',
    },
    accountDel: {
        method: 'get',
        url: `${httpUrl}/system/sysUser/delete`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/delete',
    },
    // 角色管理（账号管理）
    roleList: {
        method: 'get',
        url: `${httpUrl}/system/sysRole/list`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRole/list',
    },
    roleAll: {
        method: 'get',
        url: `${httpUrl}/system/sysRole/all`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRole/list',
    },
    
    roleAddEdit: {
        method: 'post',
        url: `${httpUrl}/system/sysRole/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRole/save',
    },
    roleDel: {
        method: 'post',
        url: `${httpUrl}/system/sysRole/removeById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRole/removeById',
    },
    // 全部角色
    roleListAll: {
        method: 'get',
        url: `${httpUrl}/system/sysRole/list`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRole/list',
    },
    fetchPermissionByRoleId: {
        method: 'get',
        url: `${httpUrl}//system/sysRolePermission/getSysPermissionByRoleId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/getSysPermissionByRoleId',
    },

    sysPermissionTreeByRoleId: {
        method: 'get',
        url: `${httpUrl}//system/sysPermission/getTreeListByRoleId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },

    sysPermissionTree: {
        method: 'get',
        url: `${httpUrl}//system/sysPermission/getTreeList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },
     

    iotPushMsg: {
        method: 'post',
        url: `${httpUrl}//iot/publish`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },

    sysPermissionSave: {
        method: 'post',
        url: `${httpUrl}//system/sysPermission/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },

    sysPermissionDel: {
        method: 'post',
        url: `${httpUrl}//system/sysPermission/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },
    aggregateAI:{
        method: 'post',
        url: `${httpUrl}//openai/aggregateAI`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },

    sendAiMsg: {
        method: 'post',
        url: `${httpUrl}//openai/getMessage1`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },
    getOpenaiMsgByTaskId: {
        method: 'get',
        url: `${httpUrl}//openaiMsg/getByTaskId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },


    sendGPTMsg: {
        method: 'post',
        url: `${httpUrl}//openai/getMessage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },

    

    savePermissionByRole: {
        method: 'post',
        url: `${httpUrl}//system/sysRolePermission/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/save',
    },

    fetchPermission: {
        method: 'get',
        url: `${httpUrl}//system/sysRolePermission/getAll`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysRolePermission/getAll',
    },

    projectList: {
        method: 'get',
        url: `${httpUrl}/api/project/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/getPageList',
    },

    projectAddEdit: {
        method: 'post',
        url: `${httpUrl}/api/project/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/save',
    },

    studentList: {
        method: 'get',
        url: `${httpUrl}/api/studentInfo/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/getPageList',
    },

    studentSave: {
        method: 'post',
        url: `${httpUrl}/api/studentInfo/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/save',
    },

    payPackageList: {
        method: 'get',
        url: `${httpUrl}/api/payPackage/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackage/getPageList',
    },

    payPackageSave: {
        method: 'post',
        url: `${httpUrl}/api/payPackage/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackage/save',
    },


    noticeList: {
        method: 'get',
        url: `${httpUrl}/api/notice/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/notice/getPageList',
    },

    noticeSave: {
        method: 'post',
        url: `${httpUrl}/api/notice/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/notice/save',
    },

    noticeDel: {
        method: 'post',
        url: `${httpUrl}/api/notice/del`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/notice/del',
    },



    deviceList: {
        method: 'get',
        url: `${httpUrl}/api/device/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/getPageList',
    },

    bleDeviceList: {
        method: 'get',
        url: `${httpUrl}/bleDevice/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/getPageList',
    },
    delBleDevice: {
        method: 'post',
        url: `${httpUrl}/bleDevice/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/device/delById',
    },


    /**
     * 入库
     */

    deviceStockIn: {
        method: 'post',
        url: `${httpUrl}/api/device/stockIn`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/stockIn',
    },

    /**
     * 出库
     */
    deviceStockOut: {
        method: 'post',
        url: `${httpUrl}/api/device/stockOut`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/stockOut',
    },

    /**
     * 出入库记
     */
    getDeviceStockOutRecord: {
        method: 'get',
        url: `${httpUrl}/deviceStockOutRecord/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceStockOutRecord/getPageList',
    },



    bleDeviceSave: {
        method: 'post',
        url: `${httpUrl}/bleDevice/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/bleDevice/save',
    },

    deviceSave: {
        method: 'post',
        url: `${httpUrl}/device/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/save',
    },
    deviceSave: {
        method: 'post',
        url: `${httpUrl}/device/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/save',
    },

    
    dbTableDelField: {
        method: 'post',
        url: `${httpUrl}/dbTable/delField`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/returnRentCheck',
    },
    dbTableAddField: {
        method: 'post',
        url: `${httpUrl}/dbTable/addField`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/returnRentCheck',
    },
    deviceFieldList: {
        method: 'get',
        url: `${httpUrl}/deviceField/getByDeviceNo`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/returnRentCheck',
    },

    deviceFieldSynchronizeCache: {
        method: 'get',
        url: `${httpUrl}/deviceField/synchronizeCache`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/returnRentCheck',
    },
    
    deviceFieldGetMap: {
        method: 'get',
        url: `${httpUrl}/deviceField/getMapByDeviceNo`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/returnRentCheck',
    },


    operationLogList: {
        method: 'get',
        url: `${httpUrl}/system/sysOperation/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysOperation/getPageList',
    },



    getProjectNodeData: {
        method: 'get',
        url: `${httpUrl}/api/project/getNodeData`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/getNodeData',
    },

    getTreeAreaInfo: {
        method: 'get',
        url: `${httpUrl}/api/projectArea/getTreeAreaInfo`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/getTreeAreaInfo',
    },
    delTreeAreaInfo: {
        method: 'get',
        url: `${httpUrl}/api/projectArea/delTreeAreaInfo`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/delTreeAreaInfo',
    },
    updateTreeAreaInfo: {
        method: 'post',
        url: `${httpUrl}/api/projectArea/updateTreeAreaInfo`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/saveTreeAreaInfo',
    },
    addTreeChildNodesAreaInfo: {
        method: 'post',
        url: `${httpUrl}/api/projectArea/addTreeChildNodesAreaInfo`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/saveTreeAreaInfo',
    },

    getProjectRoomList: {
        method: 'get',
        url: `${httpUrl}/api/projectRoom/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectRoom/getPageList',
    },
    areaInfoImportExcel: {
        method: 'get',
        url: `${httpUrl}/api/projectArea/importExcel`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },
    getOrderDepositList: {
        method: 'get',
        url: `${httpUrl}/api/order/deposit/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/deposit/getPageList',
    },
    getOrderRechargeList: {
        method: 'get',
        url: `${httpUrl}/api/order/recharge/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/recharge/getPageList',
    },
    getOrderRefundRechargeList: {
        method: 'get',
        url: `${httpUrl}/api/order/refund/recharge/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/recharge/getPageList',
    },
    getOrderRefundDepositList: {
        method: 'get',
        url: `${httpUrl}/api/order/refund/deposit/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/deposit/getPageList',
    },

    saveOrderRefundRecharge: {
        method: 'post',
        url: `${httpUrl}/api/order/refund/recharge/sysUserCreateRefund`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/recharge/sysUserCreateRefund',
    },

    allProject: {
        method: 'get',
        url: `${httpUrl}/api/project/allProject`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },


    studentBatchSettingDiscount: {
        method: 'post',
        url: `${httpUrl}/api/studentInfo/batchSettingDiscount`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/batchSettingDiscount',
    },

    //获取套餐应用页面tree 是否选中�??????
    getPayPackageRoomCheckboxIsSelect: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getCheckboxIsSelect`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getCheckboxIsSelect',
    },
    getProjectNodeChecked: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getProjectNodeChecked`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getProjectNodeChecked',
    },
    getNodeCheckedList: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getProjectNodeChecked`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getProjectNodeChecked',
    },

    getPayPackageNodeCheckedList: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getNodeCheckedList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getNodeCheckedList',
    },

    getPayPackageByProjectId: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getPayPackageByProjectId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getPayPackageByProjectId',
    },
    //获取添加的套餐列
    getCanAddPayPackageListByProjectId: {
        method: 'get',
        url: `${httpUrl}/api/payPackageRoom/getCanAddPayPackageListByProjectId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/getCanAddPayPackageListByProjectId',
    },

    //获取添加的套餐列
    addProjectPayPackage: {
        method: 'post',
        url: `${httpUrl}/api/payPackageRoom/add`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/add',
    },

    //套餐从项目中移除
    delByProjectIdAndPayPackageId: {
        method: 'post',
        url: `${httpUrl}/api/payPackageRoom/delByProjectIdAndPayPackageId`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageRoom/delByProjectIdAndPayPackageId',
    },

    //把某个房间从套餐中驱
    payPackageEvicted: {
        method: 'post',
        url: `${httpUrl}/api/payPackageEvicted/add`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageEvicted/add',
    },

    //解除�??????
    delPayPackageEvicted: {
        method: 'post',
        url: `${httpUrl}/api/payPackageEvicted/del`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackageEvicted/del',
    },

    //手机号授 查询类型
    getMobileGrantPermissionType: {
        method: 'get',
        url: `${httpUrl}/api/mobile/grantPermission/getMobileType`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mobile/grantPermission/getMobileType',
    },

    //手机号授查询类型
    getAppAdminList: {
        method: 'get',
        url: `${httpUrl}/api/appAdmin/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appAdmin/getPageList',
    },
    addAppAdmin: {
        method: 'post',
        url: `${httpUrl}/api/appAdmin/add`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appAdmin/add',
    },
    delAppAdmin: {
        method: 'post',
        url: `${httpUrl}/api/appAdmin/del`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appAdmin/del',
    },

    //保存手机号与权限
    saveUserRoomPermissions: {
        method: 'post',
        url: `${httpUrl}/api/userRoom/permissions/save`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userRoom/permissions/save',
    },
    //获取我已经有的权 的tree  懒加  为了节省服务器能
    getUserPermissionsByLevel: {
        method: 'get',
        url: `${httpUrl}/api/userRoom/permissions/getUserPermissionsByLevel`,
        mockMethod: 'get',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userRoom/permissions/getUserPermissionsByLevel',
    },

    delUserPermissionsByLevel: {
        method: 'post',
        url: `${httpUrl}/api/userRoom/permissions/delUserPermissionsByLevel`,
        mockMethod: 'post',

        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userRoom/permissions/delUserPermissionsByLevel',
    },


    getTempGrantPermissionLogList: {
        method: 'get',
        url: `${httpUrl}/api/tempGrantPermissionLog/getPageList`,
        mockMethod: 'get',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tempGrantPermissionLog/getPageList',
    },
    getRoomListByMobileNumberAndProjectId: {
        method: 'get',
        url: `${httpUrl}/api/userRoom/permissions/getRoomListByMobileNumberAndProjectId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userRoom/permissions/getRoomListByMobileNumberAndProjectId',
    },

    delStudentById: {
        method: 'post',
        url: `${httpUrl}/api/studentInfo/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/delById',

    },
    saveRoom: {
        method: 'post',
        url: `${httpUrl}/api/projectRoom/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectRoom/save',
    },
    getStudentListByRoomId: {
        method: 'get',
        url: `${httpUrl}/api/studentInfo/getListByRoomId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/studentInfo/getListByRoomId',
    },
    depositRefundAudit: {
        method: 'post',
        url: `${httpUrl}/api/order/refund/deposit/audit`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/deposit/audit',
    },
    getDeviceOperationLog: {
        method: 'get',
        url: `${httpUrl}/api/deviceOperationLog/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOperationLog/getPageList',
    },


    saveSysUserProjectRelation: {
        method: 'post',
        url: `${httpUrl}/system/sysUserProjectRelation/save`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUserProjectRelation/save',
    },
    getSysUserPermissionsByLevel: {
        method: 'get',
        url: `${httpUrl}/system/sysUserProjectRelation/getSysUserPermissionsByLevel`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUserProjectRelation/getSysUserPermissionsByLevel',
    },

    delSysUserPermissionsByLevel: {
        method: 'post',
        url: `${httpUrl}/system/sysUserProjectRelation/delSysUserPermissionsByLevel`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUserProjectRelation/delSysUserPermissionsByLevel',
    },


    delPayPackageById: {
        method: 'post',
        url: `${httpUrl}/api/payPackage/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/payPackage/delById',
    },

    sysRefundDeposit: {
        method: 'post',
        url: `${httpUrl}/api/order/refund/deposit/sysRefund`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/order/refund/deposit/sysRefund',
    },
    delProjectById: {
        method: 'post',
        url: `${httpUrl}/api/project/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/delById',
    },

    delDeviceById: {
        method: 'post',
        url: `${httpUrl}/api/device/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/delById',
    },

    deviceRentReturn: {
        method: 'post',
        url: `${httpUrl}/api/device/rentReturn`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/delById',
    },


    getStatisticalData: {
        method: 'get',
        url: `${httpUrl}/api/statistical/data`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/statistical/data',
    },
    sysUpdatePassword: {
        method: 'post',
        url: `${httpUrl}/system/sysUser/updatePassword`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/system/sysUser/updatePassword',
    },

    getHouqinbaoUserList: {
        method: 'get',
        url: `${httpUrl}/houqinbao/getPageUserInfoList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/houqinbao/getPageUserInfoList',
    },
    getHouqinbaoRoomList: {
        method: 'get',
        url: `${httpUrl}/houqinbao/getPageRoomInfoList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/houqinbao/getPageRoomInfoList',
    },



    getHouqinbaoRoomList: {
        method: 'get',
        url: `${httpUrl}/houqinbao/getPageRoomInfoList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/houqinbao/getPageRoomInfoList',
    },


    getUserSignInList: {
        method: 'get',
        url: `${httpUrl}/api/userSignIn/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userSignIn/getPageList',
    },
    getUserMobileNumberChangeRecord: {
        method: 'get',
        url: `${httpUrl}/api/userMobileNumberChangeRecord/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },




    userSave: {
        method: 'post',
        url: `${httpUrl}/user/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userList: {
        method: 'post',
        url: `${httpUrl}/user/list`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },
    userDel: {
        method: 'post',
        url: `${httpUrl}/user/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userMobileNumberChangeRecordDeleteById: {
        method: 'post',
        url: `${httpUrl}/user/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userMemberCardSave: {
        method: 'post',
        url: `${httpUrl}/userMemberCard/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userMemberCardConsume: {
        method: 'post',
        url: `${httpUrl}/userMemberCard/consume`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userExcelExport: {
        method: 'post',
        url: `${httpUrl}/user/excelExport`,
        mockMethod: 'post',
        responseType: 'blob',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },



    //产品管理


    productSkuSave: {
        method: 'post',
        url: `${httpUrl}/productSku/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },


    //sku 删除
    productSkuDeleteById: {
        method: 'post',
        url: `${httpUrl}/productSku/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    //产品列表
    productPageList: {
        method: 'post',
        url: `${httpUrl}/product/pageList`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    //产品保存
    productSave: {
        method: 'post',
        url: `${httpUrl}/product/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    //产品删除
    productDeleteById: {
        method: 'post',
        url: `${httpUrl}/product/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    productDetails: {
        method: 'post',
        url: `${httpUrl}/product/getById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    saveSku: {
        method: 'post',
        url: `${httpUrl}/productSku/save`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    userSettlement: {
        method: 'post',
        url: `${httpUrl}/user/settlement`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },





    deviceReportRecordList: {
        method: 'get',
        url: `${httpUrl}/deviceReportRecord/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    deviceReturnRentList: {
        method: 'get',
        url: `${httpUrl}/deviceReturnRent/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },



    categoryList: {
        method: 'get',
        url: `${httpUrl}/category/getByParentId`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },
    shopCategoryList: {
        method: 'get',
        url: `${httpUrl}/category/shopCategoryList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },
    categorySave: {
        method: 'post',
        url: `${httpUrl}/category/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },



    categoryDeleteById: {
        method: 'post',
        url: `${httpUrl}/category/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    /**
     * 轮播管理
     */

    bannerList: {
        method: 'get',
        url: `${httpUrl}/banner/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },

    bannerSave: {
        method: 'post',
        url: `${httpUrl}/banner/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    bannerDelById: {
        method: 'post',
        url: `${httpUrl}/banner/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },

    /**
     * 用户收货地址管理
     */

    userAddressList: {
        method: 'get',
        url: `${httpUrl}/userAddress/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },

    userAddressSave: {
        method: 'post',
        url: `${httpUrl}/userAddress/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    userAddressDelById: {
        method: 'post',
        url: `${httpUrl}/userAddress/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },



    /**
     * 经销商管
     */

    distributorList: {
        method: 'get',
        url: `${httpUrl}/userDistributor/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    distributorSave: {
        method: 'post',
        url: `${httpUrl}/userDistributor/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    distributorReview: {
        method: 'post',
        url: `${httpUrl}/userDistributor/review`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    distributorDelById: {
        method: 'post',
        url: `${httpUrl}/userDistributor/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },






    /**
     * 提现管理
     */
    userWithdrawalList: {
        method: 'get',
        url: `${httpUrl}/userWithdrawal/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    userWithdrawalSave: {
        method: 'post',
        url: `${httpUrl}/userWithdrawal/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    userWithdrawalReview: {
        method: 'post',
        url: `${httpUrl}/userWithdrawal/review`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    userWithdrawalDelById: {
        method: 'post',
        url: `${httpUrl}/userWithdrawal/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },


    //生产管理
    generateMacidDataList: {
        method: 'post',
        url: `${httpUrl}/generateMacidData/getListPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/settlement',
    },





    generateMacidDataImportExcel: {
        method: 'get',
        url: `${httpUrl}/generateMacidData/importExcel`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    deviceReportRecordList: {
        method: 'get',
        url: `${httpUrl}/deviceReportRecord/getPageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    partOrderList: {
        method: 'post',
        url: `${httpUrl}/partOrder/list`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    mpsOrderList: {
        method: 'get',
        url: `${httpUrl}/mpsOrder/getMpsOrderPage`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    partOrderExport: {
        method: 'post',
        url: `${httpUrl}/partOrder/excelExport`,
        mockMethod: 'post',
        responseType: 'blob',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    updateOrderList: {
        method: 'post',
        url: `${httpUrl}/partOrder/update`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    delOrderList: {
        method: 'post',
        url: `${httpUrl}/partOrder/delById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },



    mpsOperationOrder: {
        method: 'get',
        url: `${httpUrl}/mpsOrder/operationOrder`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/projectArea/importExcel',
    },


    /**
     * 九号 错误代码配置API
     */
    jiuhaoErrorCodeList: {
        method: 'post',
        url: `${httpUrl}/jiuhaoErrorCode/pageList`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoErrorCode/pageList',
    },

    jiuhaoErrorCodeSave: {
        method: 'post',
        url: `${httpUrl}/jiuhaoErrorCode/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoErrorCode/save',
    },


    jiuhaoErrorCodeDeleteById: {
        method: 'post',
        url: `${httpUrl}/jiuhaoErrorCode/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoErrorCode/deleteById',
    },



    /**
     * 九号 产品上报记录
     */
    jiuhaoProductionRecordList: {
        method: 'post',
        url: `${httpUrl}/jiuhaoProductionRecord/pageList`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoProductionRecord/pageList',
    },



    jiuhaoProductionRecordDeleteById: {
        method: 'post',
        url: `${httpUrl}/jiuhaoProductionRecord/deleteById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/jiuhaoProductionRecord/deleteById',
    },


    /**
     * 行车智友操作记录
     */
    bleOperationRecordList: {
        method: 'post',
        url: `${httpUrl}/bleOperationRecord/list`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },



    /**
     * ERP订单列表
     */
    erpOrderList: {
        method: 'post',
        url: `${httpUrl}/erpOrder/getListPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },



    /**
     * ERP订单计算金额
     */
    erpOrderTotalPrice: {
        method: 'post',
        url: `${httpUrl}/erpOrder/getTotalPrice`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },


    erpOrderSave: {
        method: 'post',
        url: `${httpUrl}/erpOrder/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },



    erpOrderDelById: {
        method: 'post',
        url: `${httpUrl}/erpOrder/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },





    /**
     * 评论工具
     */

    toolCommentInfoList: {
        method: 'get',
        url: `${httpUrl}/toolCommentInfo/pageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },


    toolCommentInfoDelById: {
        method: 'post',
        url: `${httpUrl}/toolCommentInfo/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },


    toolCommentInfoSave: {
        method: 'post',
        url: `${httpUrl}/toolCommentInfo/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },


    toolCommentUploadDirData: {
        method: 'post',
        url: `${httpUrl}/toolCommentInfoUploadData/uploadDirData`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },



    toolCommentInfoUploadDataImportExcel: {
        method: 'post',
        url: `${httpUrl}/toolCommentInfoUploadData/toolCommentInfoUploadDataImportExcel`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },



    /**
     * 导出ZIP
     */
    toolCommentInfoExportZip: {
        method: 'post',
        url: `${httpUrl}/toolCommentInfo/exportZip`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },


    shopList: {
        method: 'get',
        url: `${httpUrl}/shop/pageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },

    shopSave: {
        method: 'post',
        url: `${httpUrl}/shop/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },

    shopDelById: {
        method: 'post',
        url: `${httpUrl}/shop/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },



    /**
     * erp 订单
     */
    erpOrderPull: {
        method: 'post',
        url: `${httpUrl}/shop/orderPull`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bleOperationRecord/list',
    },



    erpOrderExcelExport: {
        method: 'post',
        url: `${httpUrl}/erpOrder/excelExport`,
        mockMethod: 'post',
        responseType: 'blob',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },


    erpOrderBatchExcelDeliverGoods: {
        method: 'post',
        url: `${httpUrl}/erpOrder/batchExcelDeliverGoods`,
        mockMethod: 'post',
        responseType: 'blob',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    erpOrderDeliverGoods: {
        method: 'post',
        url: `${httpUrl}/erpOrder/deliverGoods`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },



    erpProductOuterGoodsRelationSave: {
        method: 'post',
        url: `${httpUrl}/erpProductOuterGoodsRelation/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },


    erpProductOuterGoodsRelationDel: {
        method: 'post',
        url: `${httpUrl}/erpProductOuterGoodsRelation/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },

    erpProductOuterGoodsRelationList: {
        method: 'get',
        url: `${httpUrl}/erpProductOuterGoodsRelation/pageList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },




    shopUnpaidOrderList: {
        method: 'post',
        url: `${httpUrl}/order/getAdminListPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },



    tenantSave: {
        method: 'post',
        url: `${httpUrl}/tenant/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },


    tenantList: {
        method: 'post',
        url: `${httpUrl}/tenant/getPageList`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },
    tenantListAll: {
        method: 'post',
        url: `${httpUrl}/tenant/list`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },
    tenantDel: {
        method: 'post',
        url: `${httpUrl}/tenant/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },


    organizationInfo: {
        method: 'post',
        url: `${httpUrl}/tenant/organizationInfo`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },


    userDeviceList: {
        method: 'post',
        url: `${httpUrl}/userDevice/getPageList`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },
    
    userDeviceDel: {
        method: 'post',
        url: `${httpUrl}/userDevice/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/project/allProject',
    },
    shareRecordDel: {
        method: 'post',
        url: `${httpUrl}/shareRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareRecord/delById',
    },
    shareRecordSave: {
        method: 'post',
        url: `${httpUrl}/shareRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareRecord/save',
    },
    shareRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/shareRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareRecord/queryPage',
    },
    shareRecordFindById: {
        method: 'get',
        url: `${httpUrl}/shareRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareRecord/findById',
    },
    sysCodeGenerationRecordDel: {
        method: 'post',
        url: `${httpUrl}/sysCodeGenerationRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysCodeGenerationRecord/delById',
    },
    sysCodeGenerationRecordSave: {
        method: 'post',
        url: `${httpUrl}/sysCodeGenerationRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysCodeGenerationRecord/save',
    },
    sysCodeGenerationRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysCodeGenerationRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysCodeGenerationRecord/queryPage',
    },
    sysCodeGenerationRecordFindById: {
        method: 'get',
        url: `${httpUrl}/sysCodeGenerationRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysCodeGenerationRecord/findById',
    },
    sysApiTesrecordDel: {
        method: 'post',
        url: `${httpUrl}/sysApiTesrecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTesrecord/delById',
    },
    sysApiTesrecordSave: {
        method: 'post',
        url: `${httpUrl}/sysApiTesrecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTesrecord/save',
    },
    sysApiTesrecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysApiTesrecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTesrecord/queryPage',
    },
    sysApiTesrecordFindById: {
        method: 'get',
        url: `${httpUrl}/sysApiTesrecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTesrecord/findById',
    },
    sysApiTestRecordDel: {
        method: 'post',
        url: `${httpUrl}/sysApiTestRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTestRecord/delById',
    },
    sysApiTestRecordSave: {
        method: 'post',
        url: `${httpUrl}/sysApiTestRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTestRecord/save',
    },
    sysApiTestRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysApiTestRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTestRecord/queryPage',
    },
    sysApiTestRecordFindById: {
        method: 'get',
        url: `${httpUrl}/sysApiTestRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTestRecord/findById',
    },
    smsTemplateDel: {
        method: 'post',
        url: `${httpUrl}/smsTemplate/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/smsTemplate/delById',
    },
    smsTemplateSave: {
        method: 'post',
        url: `${httpUrl}/smsTemplate/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/smsTemplate/save',
    },
    smsTemplateQueryPage: {
        method: 'post',
        url: `${httpUrl}/smsTemplate/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/smsTemplate/queryPage',
    },
    smsTemplateFindById: {
        method: 'get',
        url: `${httpUrl}/smsTemplate/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/smsTemplate/findById',
    },
    fileStorageConfigDel: {
        method: 'post',
        url: `${httpUrl}/fileStorageConfig/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileStorageConfig/delById',
    },
    fileStorageConfigSave: {
        method: 'post',
        url: `${httpUrl}/fileStorageConfig/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileStorageConfig/save',
    },
    fileStorageConfigQueryPage: {
        method: 'post',
        url: `${httpUrl}/fileStorageConfig/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileStorageConfig/queryPage',
    },
    fileStorageConfigFindById: {
        method: 'get',
        url: `${httpUrl}/fileStorageConfig/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileStorageConfig/findById',
    },
    fileSystemDel: {
        method: 'post',
        url: `${httpUrl}/fileSystem/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileSystem/delById',
    },
    fileSystemSave: {
        method: 'post',
        url: `${httpUrl}/fileSystem/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileSystem/save',
    },
    fileSystemQueryPage: {
        method: 'post',
        url: `${httpUrl}/fileSystem/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileSystem/queryPage',
    },
    fileSystemFindById: {
        method: 'get',
        url: `${httpUrl}/fileSystem/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileSystem/findById',
    },
    sysGlobalConfigDel: {
        method: 'post',
        url: `${httpUrl}/sysGlobalConfig/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysGlobalConfig/delById',
    },
    sysGlobalConfigSave: {
        method: 'post',
        url: `${httpUrl}/sysGlobalConfig/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysGlobalConfig/save',
    },
    sysGlobalConfigQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysGlobalConfig/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysGlobalConfig/queryPage',
    },
    sysGlobalConfigFindById: {
        method: 'get',
        url: `${httpUrl}/sysGlobalConfig/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysGlobalConfig/findById',
    },
    smsRecordDel: {
        method: 'post',
        url: `${httpUrl}/smsRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/smsRecord/delById',
    },
    smsRecordSave: {
        method: 'post',
        url: `${httpUrl}/smsRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/smsRecord/save',
    },
    smsRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/smsRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/smsRecord/queryPage',
    },
    smsRecordFindById: {
        method: 'get',
        url: `${httpUrl}/smsRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/smsRecord/findById',
    },
    dealerDel: {
        method: 'post',
        url: `${httpUrl}/dealer/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dealer/delById',
    },
    dealerSave: {
        method: 'post',
        url: `${httpUrl}/dealer/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dealer/save',
    },
    dealerQueryPage: {
        method: 'post',
        url: `${httpUrl}/dealer/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dealer/queryPage',
    },
    dealerFindById: {
        method: 'get',
        url: `${httpUrl}/dealer/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dealer/findById',
    },
    rentCabinetDel: {
        method: 'post',
        url: `${httpUrl}/rentCabinet/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinet/delById',
    },
    rentCabinetSave: {
        method: 'post',
        url: `${httpUrl}/rentCabinet/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinet/save',
    },
    rentCabinetQueryPage: {
        method: 'post',
        url: `${httpUrl}/rentCabinet/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinet/queryPage',
    },
    rentCabinetFindById: {
        method: 'get',
        url: `${httpUrl}/rentCabinet/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinet/findById',
    },
    dealerAllList: {
        method: 'get',
        url: `${httpUrl}/dealer/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dealer/allList',
    },
    userAllList: {
        method: 'get',
        url: `${httpUrl}/user/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/user/allList',
    },
    rentCabinetAllList: {
        method: 'get',
        url: `${httpUrl}/rentCabinet/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinet/allList',
    },
    openPlatformKeyDel: {
        method: 'post',
        url: `${httpUrl}/openPlatformKey/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openPlatformKey/delById',
    },
    openPlatformKeySave: {
        method: 'post',
        url: `${httpUrl}/openPlatformKey/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openPlatformKey/save',
    },
    openPlatformKeyQueryPage: {
        method: 'post',
        url: `${httpUrl}/openPlatformKey/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openPlatformKey/queryPage',
    },
    openPlatformKeyFindById: {
        method: 'get',
        url: `${httpUrl}/openPlatformKey/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openPlatformKey/findById',
    },
    openPlatformKeyAllList: {
        method: 'get',
        url: `${httpUrl}/openPlatformKey/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openPlatformKey/allList',
    },
    rentOrderDel: {
        method: 'post',
        url: `${httpUrl}/rentOrder/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrder/delById',
    },
    rentOrderSave: {
        method: 'post',
        url: `${httpUrl}/rentOrder/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrder/save',
    },
    rentOrderQueryPage: {
        method: 'post',
        url: `${httpUrl}/rentOrder/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrder/queryPage',
    },
    rentOrderFindById: {
        method: 'get',
        url: `${httpUrl}/rentOrder/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrder/findById',
    },
    rentOrderAllList: {
        method: 'get',
        url: `${httpUrl}/rentOrder/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrder/allList',
    },
    rentOrderItemDel: {
        method: 'post',
        url: `${httpUrl}/rentOrderItem/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrderItem/delById',
    },
    rentOrderItemSave: {
        method: 'post',
        url: `${httpUrl}/rentOrderItem/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrderItem/save',
    },
    rentOrderItemQueryPage: {
        method: 'post',
        url: `${httpUrl}/rentOrderItem/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrderItem/queryPage',
    },
    rentOrderItemFindById: {
        method: 'get',
        url: `${httpUrl}/rentOrderItem/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrderItem/findById',
    },
    rentOrderItemAllList: {
        method: 'get',
        url: `${httpUrl}/rentOrderItem/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentOrderItem/allList',
    },
    huapinDeviceDel: {
        method: 'post',
        url: `${httpUrl}/huapinDevice/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinDevice/delById',
    },
    huapinDeviceSave: {
        method: 'post',
        url: `${httpUrl}/huapinDevice/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinDevice/save',
    },
    huapinDeviceQueryPage: {
        method: 'post',
        url: `${httpUrl}/huapinDevice/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinDevice/queryPage',
    },
    huapinDeviceFindById: {
        method: 'get',
        url: `${httpUrl}/huapinDevice/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinDevice/findById',
    },
    huapinDeviceAllList: {
        method: 'get',
        url: `${httpUrl}/huapinDevice/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinDevice/allList',
    },
    huapinRentCabinetDeviceDel: {
        method: 'post',
        url: `${httpUrl}/huapinRentCabinetDevice/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinRentCabinetDevice/delById',
    },
    huapinRentCabinetDeviceSave: {
        method: 'post',
        url: `${httpUrl}/huapinRentCabinetDevice/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinRentCabinetDevice/save',
    },
    huapinRentCabinetDeviceQueryPage: {
        method: 'post',
        url: `${httpUrl}/huapinRentCabinetDevice/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinRentCabinetDevice/queryPage',
    },
    huapinRentCabinetDeviceFindById: {
        method: 'get',
        url: `${httpUrl}/huapinRentCabinetDevice/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinRentCabinetDevice/findById',
    },
    huapinRentCabinetDeviceAllList: {
        method: 'get',
        url: `${httpUrl}/huapinRentCabinetDevice/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinRentCabinetDevice/allList',
    },
    rentCabinetDeviceDel: {
        method: 'post',
        url: `${httpUrl}/rentCabinetDevice/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinetDevice/delById',
    },
    rentCabinetDeviceSave: {
        method: 'post',
        url: `${httpUrl}/rentCabinetDevice/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinetDevice/save',
    },
    rentCabinetDeviceQueryPage: {
        method: 'post',
        url: `${httpUrl}/rentCabinetDevice/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinetDevice/queryPage',
    },
    rentCabinetDeviceFindById: {
        method: 'get',
        url: `${httpUrl}/rentCabinetDevice/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinetDevice/findById',
    },
    rentCabinetDeviceAllList: {
        method: 'get',
        url: `${httpUrl}/rentCabinetDevice/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rentCabinetDevice/allList',
    },
    openaiMsgDel: {
        method: 'post',
        url: `${httpUrl}/openaiMsg/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openaiMsg/delById',
    },
    openaiMsgSave: {
        method: 'post',
        url: `${httpUrl}/openaiMsg/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openaiMsg/save',
    },
    openaiMsgQueryPage: {
        method: 'post',
        url: `${httpUrl}/openaiMsg/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openaiMsg/queryPage',
    },
    openaiMsgFindById: {
        method: 'get',
        url: `${httpUrl}/openaiMsg/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openaiMsg/findById',
    },
    openaiMsgAllList: {
        method: 'get',
        url: `${httpUrl}/openaiMsg/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/openaiMsg/allList',
    },
    sysApiTestProjectDel: {
        method: 'post',
        url: `${httpUrl}/sysApiTestProject/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTestProject/delById',
    },
    sysApiTestProjectSave: {
        method: 'post',
        url: `${httpUrl}/sysApiTestProject/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTestProject/save',
    },
    sysApiTestProjectQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysApiTestProject/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTestProject/queryPage',
    },
    sysApiTestProjectFindById: {
        method: 'get',
        url: `${httpUrl}/sysApiTestProject/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTestProject/findById',
    },
    sysApiTestProjectAllList: {
        method: 'get',
        url: `${httpUrl}/sysApiTestProject/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysApiTestProject/allList',
    },
    supplierDel: {
        method: 'post',
        url: `${httpUrl}/supplier/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/supplier/delById',
    },
    supplierSave: {
        method: 'post',
        url: `${httpUrl}/supplier/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/supplier/save',
    },
    supplierQueryPage: {
        method: 'post',
        url: `${httpUrl}/supplier/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/supplier/queryPage',
    },
    supplierFindById: {
        method: 'get',
        url: `${httpUrl}/supplier/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/supplier/findById',
    },
    supplierAllList: {
        method: 'get',
        url: `${httpUrl}/supplier/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/supplier/allList',
    },
    userSpCartDel: {
        method: 'post',
        url: `${httpUrl}/userSpCart/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userSpCart/delById',
    },
    userSpCartSave: {
        method: 'post',
        url: `${httpUrl}/userSpCart/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userSpCart/save',
    },
    userSpCartQueryPage: {
        method: 'post',
        url: `${httpUrl}/userSpCart/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userSpCart/queryPage',
    },
    userSpCartFindById: {
        method: 'get',
        url: `${httpUrl}/userSpCart/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userSpCart/findById',
    },
    userSpCartAllList: {
        method: 'get',
        url: `${httpUrl}/userSpCart/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userSpCart/allList',
    },
    communityDel: {
        method: 'post',
        url: `${httpUrl}/community/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/community/delById',
    },
    communitySave: {
        method: 'post',
        url: `${httpUrl}/community/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/community/save',
    },
    communityQueryPage: {
        method: 'post',
        url: `${httpUrl}/community/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/community/queryPage',
    },
    communityFindById: {
        method: 'get',
        url: `${httpUrl}/community/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/community/findById',
    },
    communityAllList: {
        method: 'get',
        url: `${httpUrl}/community/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/community/allList',
    },
    tradeOrderDel: {
        method: 'post',
        url: `${httpUrl}/tradeOrder/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrder/delById',
    },
    tradeOrderSave: {
        method: 'post',
        url: `${httpUrl}/tradeOrder/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrder/save',
    },
    tradeOrderQueryPage: {
        method: 'post',
        url: `${httpUrl}/tradeOrder/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrder/queryPage',
    },
    tradeOrderFindById: {
        method: 'get',
        url: `${httpUrl}/tradeOrder/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrder/findById',
    },
    tradeOrderAllList: {
        method: 'get',
        url: `${httpUrl}/tradeOrder/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrder/allList',
    },
    tradeOrderItemDel: {
        method: 'post',
        url: `${httpUrl}/tradeOrderItem/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrderItem/delById',
    },
    tradeOrderItemSave: {
        method: 'post',
        url: `${httpUrl}/tradeOrderItem/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrderItem/save',
    },
    tradeOrderItemQueryPage: {
        method: 'post',
        url: `${httpUrl}/tradeOrderItem/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrderItem/queryPage',
    },
    tradeOrderItemFindById: {
        method: 'get',
        url: `${httpUrl}/tradeOrderItem/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrderItem/findById',
    },
    tradeOrderItemAllList: {
        method: 'get',
        url: `${httpUrl}/tradeOrderItem/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tradeOrderItem/allList',
    },
    wxOfficialAccountIndustryCodeDel: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountIndustryCode/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustryCode/delById',
    },
    wxOfficialAccountIndustryCodeSave: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountIndustryCode/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustryCode/save',
    },
    wxOfficialAccountIndustryCodeQueryPage: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountIndustryCode/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustryCode/queryPage',
    },
    wxOfficialAccountIndustryCodeFindById: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountIndustryCode/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustryCode/findById',
    },
    wxOfficialAccountIndustryCodeAllList: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountIndustryCode/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustryCode/allList',
    },
    wxOfficialAccountIndustryDel: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountIndustry/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustry/delById',
    },
    wxOfficialAccountIndustrySave: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountIndustry/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustry/save',
    },
    wxOfficialAccountIndustryQueryPage: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountIndustry/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustry/queryPage',
    },
    wxOfficialAccountIndustryFindById: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountIndustry/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustry/findById',
    },
    wxOfficialAccountIndustryAllList: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountIndustry/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountIndustry/allList',
    },
    wxOfficialAccountDel: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccount/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccount/delById',
    },
    wxOfficialAccountSave: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccount/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccount/save',
    },
    wxOfficialAccountQueryPage: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccount/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccount/queryPage',
    },
    wxOfficialAccountFindById: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccount/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccount/findById',
    },
    wxOfficialAccountAllList: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccount/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccount/allList',
    },
    wxOfficialAccountRefreshAccessToken: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccount/refreshAccessToken`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccount/refreshAccessToken',
    },
    
    wxOfficialAccountMessageTemplateDel: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountMessageTemplate/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplate/delById',
    },
    wxOfficialAccountMessageTemplateSave: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountMessageTemplate/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplate/save',
    },
    wxOfficialAccountMessageTemplateQueryPage: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountMessageTemplate/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplate/queryPage',
    },
    wxOfficialAccountMessageTemplateFindById: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountMessageTemplate/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplate/findById',
    },
    wxOfficialAccountMessageTemplateAllList: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountMessageTemplate/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplate/allList',
    },
    wxOfficialAccountMessageTemplateRelationDel: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRelation/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRelation/delById',
    },
    wxOfficialAccountMessageTemplateRelationSave: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRelation/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRelation/save',
    },
    wxOfficialAccountMessageTemplateRelationQueryPage: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRelation/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRelation/queryPage',
    },
    wxOfficialAccountMessageTemplateRelationFindById: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRelation/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRelation/findById',
    },
    wxOfficialAccountMessageTemplateRelationAllList: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRelation/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRelation/allList',
    },
    wxOfficialAccountMessageTemplateRecordDel: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRecord/delById',
    },
    wxOfficialAccountMessageTemplateRecordSave: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRecord/save',
    },
    wxOfficialAccountMessageTemplateRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRecord/queryPage',
    },
    wxOfficialAccountMessageTemplateRecordFindById: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRecord/findById',
    },
    wxOfficialAccountMessageTemplateRecordAllList: {
        method: 'get',
        url: `${httpUrl}/wxOfficialAccountMessageTemplateRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccountMessageTemplateRecord/allList',
    },
    userOauthDel: {
        method: 'post',
        url: `${httpUrl}/userOauth/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userOauth/delById',
    },
    userOauthSave: {
        method: 'post',
        url: `${httpUrl}/userOauth/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userOauth/save',
    },
    userOauthQueryPage: {
        method: 'post',
        url: `${httpUrl}/userOauth/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userOauth/queryPage',
    },
    userOauthFindById: {
        method: 'get',
        url: `${httpUrl}/userOauth/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userOauth/findById',
    },
    userOauthAllList: {
        method: 'get',
        url: `${httpUrl}/userOauth/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userOauth/allList',
    },
    wxOfficialAccountPullUser: {
        method: 'post',
        url: `${httpUrl}/wxOfficialAccount/pullUser`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/wxOfficialAccount/pullUser',
    },
    
    shopTableDel: {
        method: 'post',
        url: `${httpUrl}/shopTable/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTable/delById',
    },
    shopTableSave: {
        method: 'post',
        url: `${httpUrl}/shopTable/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTable/save',
    },
    shopTableOpenTable: {
        method: 'post',
        url: `${httpUrl}/shopTable/openTable`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTable/openTable',
    },
    shopTableCloseTable: {
        method: 'post',
        url: `${httpUrl}/shopTable/closeTable`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTable/closeTable',
    },
    shopTableToOrder: {
        method: 'post',
        url: `${httpUrl}/shopTable/toOrder`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTable/toOrder',
    },

    
    shopTableQueryPage: {
        method: 'post',
        url: `${httpUrl}/shopTable/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTable/queryPage',
    },
    shopTableFindById: {
        method: 'get',
        url: `${httpUrl}/shopTable/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTable/findById',
    },
    shopTableAllList: {
        method: 'get',
        url: `${httpUrl}/shopTable/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTable/allList',
    },
    shopAreaDel: {
        method: 'post',
        url: `${httpUrl}/shopArea/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopArea/delById',
    },
    shopAreaSave: {
        method: 'post',
        url: `${httpUrl}/shopArea/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopArea/save',
    },
    shopAreaQueryPage: {
        method: 'post',
        url: `${httpUrl}/shopArea/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopArea/queryPage',
    },
    shopAreaFindById: {
        method: 'get',
        url: `${httpUrl}/shopArea/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopArea/findById',
    },
    shopAreaAllList: {
        method: 'get',
        url: `${httpUrl}/shopArea/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopArea/allList',
    },
    sharePageDel: {
        method: 'post',
        url: `${httpUrl}/sharePage/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sharePage/delById',
    },
    sharePageSave: {
        method: 'post',
        url: `${httpUrl}/sharePage/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sharePage/save',
    },
    sharePageQueryPage: {
        method: 'post',
        url: `${httpUrl}/sharePage/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sharePage/queryPage',
    },
    sharePageFindById: {
        method: 'get',
        url: `${httpUrl}/sharePage/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sharePage/findById',
    },
    sharePageAllList: {
        method: 'get',
        url: `${httpUrl}/sharePage/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sharePage/allList',
    },
    shopAllList: {
        method: 'get',
        url: `${httpUrl}/shop/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sharePage/allList',
    },
    shareConfigDel: {
        method: 'post',
        url: `${httpUrl}/shareConfig/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareConfig/delById',
    },
    shareConfigSave: {
        method: 'post',
        url: `${httpUrl}/shareConfig/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareConfig/save',
    },
    shareConfigQueryPage: {
        method: 'post',
        url: `${httpUrl}/shareConfig/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareConfig/queryPage',
    },
    shareConfigFindById: {
        method: 'get',
        url: `${httpUrl}/shareConfig/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareConfig/findById',
    },
    shareConfigAllList: {
        method: 'get',
        url: `${httpUrl}/shareConfig/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareConfig/allList',
    },
    shareClickRecordDel: {
        method: 'post',
        url: `${httpUrl}/shareClickRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareClickRecord/delById',
    },
    shareClickRecordSave: {
        method: 'post',
        url: `${httpUrl}/shareClickRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareClickRecord/save',
    },
    shareClickRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/shareClickRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareClickRecord/queryPage',
    },
    shareClickRecordFindById: {
        method: 'get',
        url: `${httpUrl}/shareClickRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareClickRecord/findById',
    },
    shareClickRecordAllList: {
        method: 'get',
        url: `${httpUrl}/shareClickRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareClickRecord/allList',
    },
    shareRecordAllList: {
        method: 'get',
        url: `${httpUrl}/shareRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shareRecord/allList',
    },
    huaruiStoreDel: {
        method: 'post',
        url: `${httpUrl}/huaruiStore/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiStore/delById',
    },
    huaruiStoreSave: {
        method: 'post',
        url: `${httpUrl}/huaruiStore/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiStore/save',
    },
    huaruiStoreQueryPage: {
        method: 'post',
        url: `${httpUrl}/huaruiStore/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiStore/queryPage',
    },
    huaruiStoreFindById: {
        method: 'get',
        url: `${httpUrl}/huaruiStore/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiStore/findById',
    },
    huaruiStoreAllList: {
        method: 'get',
        url: `${httpUrl}/huaruiStore/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiStore/allList',
    },
    bomcaDel: {
        method: 'post',
        url: `${httpUrl}/bomca/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bomca/delById',
    },
    bomcaSave: {
        method: 'post',
        url: `${httpUrl}/bomca/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bomca/save',
    },
    bomcaQueryPage: {
        method: 'post',
        url: `${httpUrl}/bomca/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bomca/queryPage',
    },
    bomcaFindById: {
        method: 'get',
        url: `${httpUrl}/bomca/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bomca/findById',
    },
    bomcaAllList: {
        method: 'get',
        url: `${httpUrl}/bomca/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bomca/allList',
    },
    hupinErpYfDel: {
        method: 'post',
        url: `${httpUrl}/hupinErpYf/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYf/delById',
    },
    hupinErpYfSave: {
        method: 'post',
        url: `${httpUrl}/hupinErpYf/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYf/save',
    },
    hupinErpYfQueryPage: {
        method: 'post',
        url: `${httpUrl}/hupinErpYf/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYf/queryPage',
    },
    hupinErpYfFindById: {
        method: 'get',
        url: `${httpUrl}/hupinErpYf/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYf/findById',
    },
    hupinErpYfAllList: {
        method: 'get',
        url: `${httpUrl}/hupinErpYf/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYf/allList',
    },

    yfErpBomExcelExport: {
        method: 'post',
        url: `${httpUrl}/hupinErpYf/excelExport`,
        mockMethod: 'post',
        responseType: 'blob',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userMobileNumberChangeRecord/getPageList',
    },
    huapinHairDryerDrawDel: {
        method: 'post',
        url: `${httpUrl}/huapinHairDryerDraw/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinHairDryerDraw/delById',
    },
    huapinHairDryerDrawSave: {
        method: 'post',
        url: `${httpUrl}/huapinHairDryerDraw/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinHairDryerDraw/save',
    },
    huapinHairDryerDrawQueryPage: {
        method: 'post',
        url: `${httpUrl}/huapinHairDryerDraw/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinHairDryerDraw/queryPage',
    },
    huapinHairDryerDrawFindById: {
        method: 'get',
        url: `${httpUrl}/huapinHairDryerDraw/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinHairDryerDraw/findById',
    },
    huapinHairDryerDrawAllList: {
        method: 'get',
        url: `${httpUrl}/huapinHairDryerDraw/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huapinHairDryerDraw/allList',
    },

    bmsBatteryFaultsConfigDel: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryFaultsConfig/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsConfig/delById',
    },
    bmsBatteryFaultsConfigSave: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryFaultsConfig/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsConfig/save',
    },
    bmsBatteryFaultsConfigQueryPage: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryFaultsConfig/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsConfig/queryPage',
    },
    bmsBatteryFaultsConfigFindById: {
        method: 'get',
        url: `${httpUrl}/bmsBatteryFaultsConfig/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsConfig/findById',
    },
    bmsBatteryFaultsConfigAllList: {
        method: 'get',
        url: `${httpUrl}/bmsBatteryFaultsConfig/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsConfig/allList',
    },
    bmsDeviceDel: {
        method: 'post',
        url: `${httpUrl}/bmsDevice/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsDevice/delById',
    },
    bmsDeviceSave: {
        method: 'post',
        url: `${httpUrl}/bmsDevice/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsDevice/save',
    },
    bmsDeviceQueryPage: {
        method: 'post',
        url: `${httpUrl}/bmsDevice/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsDevice/queryPage',
    },
    bmsDeviceFindById: {
        method: 'get',
        url: `${httpUrl}/bmsDevice/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsDevice/findById',
    },
    bmsDeviceAllList: {
        method: 'get',
        url: `${httpUrl}/bmsDevice/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsDevice/allList',
    },
    bmsBatteryFaultsRecordDel: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryFaultsRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsRecord/delById',
    },
    bmsBatteryFaultsRecordSave: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryFaultsRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsRecord/save',
    },
    bmsBatteryFaultsRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryFaultsRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsRecord/queryPage',
    },
    bmsBatteryFaultsRecordFindById: {
        method: 'get',
        url: `${httpUrl}/bmsBatteryFaultsRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsRecord/findById',
    },
    bmsBatteryFaultsRecordAllList: {
        method: 'get',
        url: `${httpUrl}/bmsBatteryFaultsRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryFaultsRecord/allList',
    },
    sysUserRoleDel: {
        method: 'post',
        url: `${httpUrl}/sysUserRole/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserRole/delById',
    },
    sysUserRoleSave: {
        method: 'post',
        url: `${httpUrl}/sysUserRole/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserRole/save',
    },
    sysUserRoleQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysUserRole/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserRole/queryPage',
    },
    sysUserRoleFindById: {
        method: 'get',
        url: `${httpUrl}/sysUserRole/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserRole/findById',
    },
    sysUserRoleAllList: {
        method: 'get',
        url: `${httpUrl}/sysUserRole/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserRole/allList',
    },
    userDeviceBindingDel: {
        method: 'post',
        url: `${httpUrl}/userDeviceBinding/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userDeviceBinding/delById',
    },
    userDeviceBindingSave: {
        method: 'post',
        url: `${httpUrl}/userDeviceBinding/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userDeviceBinding/save',
    },
    userDeviceBindingQueryPage: {
        method: 'post',
        url: `${httpUrl}/userDeviceBinding/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userDeviceBinding/queryPage',
    },
    userDeviceBindingFindById: {
        method: 'get',
        url: `${httpUrl}/userDeviceBinding/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userDeviceBinding/findById',
    },
    userDeviceBindingAllList: {
        method: 'get',
        url: `${httpUrl}/userDeviceBinding/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userDeviceBinding/allList',
    },
    deviceCardDel: {
        method: 'post',
        url: `${httpUrl}/deviceCard/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceCard/delById',
    },
    deviceCardSave: {
        method: 'post',
        url: `${httpUrl}/deviceCard/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceCard/save',
    },
    deviceCardQueryPage: {
        method: 'post',
        url: `${httpUrl}/deviceCard/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceCard/queryPage',
    },
    deviceCardFindById: {
        method: 'get',
        url: `${httpUrl}/deviceCard/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceCard/findById',
    },
    deviceCardAllList: {
        method: 'get',
        url: `${httpUrl}/deviceCard/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceCard/allList',
    },
    deviceOperationLogDel: {
        method: 'post',
        url: `${httpUrl}/deviceOperationLog/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOperationLog/delById',
    },
    deviceOperationLogSave: {
        method: 'post',
        url: `${httpUrl}/deviceOperationLog/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOperationLog/save',
    },
    deviceOperationLogQueryPage: {
        method: 'post',
        url: `${httpUrl}/deviceOperationLog/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOperationLog/queryPage',
    },
    deviceOperationLogFindById: {
        method: 'get',
        url: `${httpUrl}/deviceOperationLog/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOperationLog/findById',
    },
    deviceOperationLogAllList: {
        method: 'get',
        url: `${httpUrl}/deviceOperationLog/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOperationLog/allList',
    },
    bmsUploadDataDel: {
        method: 'post',
        url: `${httpUrl}/bmsUploadData/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsUploadData/delById',
    },
    bmsUploadDataSave: {
        method: 'post',
        url: `${httpUrl}/bmsUploadData/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsUploadData/save',
    },
    bmsUploadDataQueryPage: {
        method: 'post',
        url: `${httpUrl}/bmsUploadData/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsUploadData/queryPage',
    },
    bmsUploadDataFindById: {
        method: 'get',
        url: `${httpUrl}/bmsUploadData/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsUploadData/findById',
    },
    bmsUploadDataAllList: {
        method: 'get',
        url: `${httpUrl}/bmsUploadData/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsUploadData/allList',
    },
    dbTableDel: {
        method: 'post',
        url: `${httpUrl}/dbTable/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbTable/delById',
    },
    dbTableSave: {
        method: 'post',
        url: `${httpUrl}/dbTable/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbTable/save',
    },
    dbTableQueryPage: {
        method: 'post',
        url: `${httpUrl}/dbTable/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbTable/queryPage',
    },
    dbTableFindById: {
        method: 'get',
        url: `${httpUrl}/dbTable/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbTable/findById',
    },
    dbTableAllList: {
        method: 'get',
        url: `${httpUrl}/dbTable/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbTable/allList',
    },
    dbSourceDel: {
        method: 'post',
        url: `${httpUrl}/dbSource/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbSource/delById',
    },
    dbSourceSave: {
        method: 'post',
        url: `${httpUrl}/dbSource/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbSource/save',
    },
    dbSourceQueryPage: {
        method: 'post',
        url: `${httpUrl}/dbSource/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbSource/queryPage',
    },
    dbSourceFindById: {
        method: 'get',
        url: `${httpUrl}/dbSource/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbSource/findById',
    },
    dbSourceAllList: {
        method: 'get',
        url: `${httpUrl}/dbSource/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbSource/allList',
    },
    dbTableTableFields: {
        method: 'post',
        url: `${httpUrl}/dbTable/tableFields`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbSource/allList',
    },

    dbSourceExecuteSql: {
        method: 'post',
        url: `${httpUrl}/dbSource/executeSql`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbSource/allList',
    },
    
    tableDescribeDel: {
        method: 'post',
        url: `${httpUrl}/tableDescribe/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tableDescribe/delById',
    },
    tableDescribeSave: {
        method: 'post',
        url: `${httpUrl}/tableDescribe/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tableDescribe/save',
    },
    tableDescribeQueryPage: {
        method: 'post',
        url: `${httpUrl}/tableDescribe/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tableDescribe/queryPage',
    },
    tableDescribeFindById: {
        method: 'get',
        url: `${httpUrl}/tableDescribe/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tableDescribe/findById',
    },
    tableDescribeAllList: {
        method: 'get',
        url: `${httpUrl}/tableDescribe/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/tableDescribe/allList',
    },
    dbMainQueryDel: {
        method: 'post',
        url: `${httpUrl}/dbMainQuery/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQuery/delById',
    },
    dbMainQuerySave: {
        method: 'post',
        url: `${httpUrl}/dbMainQuery/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQuery/save',
    },
    dbMainQueryQueryPage: {
        method: 'post',
        url: `${httpUrl}/dbMainQuery/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQuery/queryPage',
    },
    dbMainQueryFindById: {
        method: 'get',
        url: `${httpUrl}/dbMainQuery/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQuery/findById',
    },
    dbMainQueryAllList: {
        method: 'get',
        url: `${httpUrl}/dbMainQuery/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQuery/allList',
    },

    dbMainQuerySqlQuery: {
        method: 'post',
        url: `${httpUrl}/dbMainQuery/sqlQuery`,
        mockMethod: 'post',
        isJSon: true,
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQuery/allList',
    },

    
    customerLeadsDel: {
        method: 'post',
        url: `${httpUrl}/customerLeads/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/customerLeads/delById',
    },
    customerLeadsSave: {
        method: 'post',
        url: `${httpUrl}/customerLeads/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/customerLeads/save',
    },
    customerLeadsQueryPage: {
        method: 'post',
        url: `${httpUrl}/customerLeads/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/customerLeads/queryPage',
    },
    customerLeadsFindById: {
        method: 'get',
        url: `${httpUrl}/customerLeads/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/customerLeads/findById',
    },
    customerLeadsAllList: {
        method: 'get',
        url: `${httpUrl}/customerLeads/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/customerLeads/allList',
    },
    dbMainQueryConditionDel: {
        method: 'post',
        url: `${httpUrl}/dbMainQueryCondition/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQueryCondition/delById',
    },
    dbMainQueryConditionSave: {
        method: 'post',
        url: `${httpUrl}/dbMainQueryCondition/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQueryCondition/save',
    },
    dbMainQueryConditionQueryPage: {
        method: 'post',
        url: `${httpUrl}/dbMainQueryCondition/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQueryCondition/queryPage',
    },
    dbMainQueryConditionFindById: {
        method: 'get',
        url: `${httpUrl}/dbMainQueryCondition/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQueryCondition/findById',
    },
    dbMainQueryConditionAllList: {
        method: 'get',
        url: `${httpUrl}/dbMainQueryCondition/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dbMainQueryCondition/allList',
    },
    hupinErpYfReportFormsDel: {
        method: 'post',
        url: `${httpUrl}/hupinErpYfReportForms/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYfReportForms/delById',
    },
    hupinErpYfReportFormsSave: {
        method: 'post',
        url: `${httpUrl}/hupinErpYfReportForms/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYfReportForms/save',
    },
    hupinErpYfReportFormsQueryPage: {
        method: 'post',
        url: `${httpUrl}/hupinErpYfReportForms/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYfReportForms/queryPage',
    },
    hupinErpYfReportFormsFindById: {
        method: 'get',
        url: `${httpUrl}/hupinErpYfReportForms/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYfReportForms/findById',
    },
    hupinErpYfReportFormsAllList: {
        method: 'get',
        url: `${httpUrl}/hupinErpYfReportForms/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/hupinErpYfReportForms/allList',
    },
    bmsBatteryPackInfoDel: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryPackInfo/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/delById',
    },
    bmsBatteryPackInfoSave: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryPackInfo/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/save',
    },
    bmsBatteryPackInfoQueryPage: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryPackInfo/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/queryPage',
    },
    bmsBatteryPackInfoFindById: {
        method: 'get',
        url: `${httpUrl}/bmsBatteryPackInfo/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/findById',
    },
    bmsBatteryPackInfoAllList: {
        method: 'get',
        url: `${httpUrl}/bmsBatteryPackInfo/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/allList',
    },

    stockDetailedLedger: {
        method: 'post',
        url: `${httpUrl}/dbMainQuery/businessDataQuery/Bill_STATISTICS_REPORT001`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/allList',
        isJSon: true,
    },

    onlineList: {
        method: 'post',
        url: `${httpUrl}/dbMainQuery/businessDataQuery/`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/allList',
        isJSon: true,
        isUrlRest:true,
    },
    onlinePageList: {
        method: 'post',
        url: `${httpUrl}/dbMainQuery/pageList/`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/allList',
        isJSon: true,
        isUrlRest:true,
    },
    onlineExport: {
        method: 'post',
        url: `${httpUrl}/dbMainQuery/excelExport/`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/allList',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:true,
    },
    stockDetailedLedgerExport: {
        method: 'post',
        url: `${httpUrl}/dbMainQuery/excelExport/Bill_STATISTICS_REPORT001`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/allList',
        isJSon: true,
        responseType: 'blob',
    },

    downloadMenu: {
        method: 'post',
        url: `${httpUrl}/product/downloadMenu`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/product/downloadMenu',
        isJSon: true,
        responseType: 'blob',
    },

    downloadPdfEmployee: {
        method: 'post',
        url: `${httpUrl}/employee/downloadPdf`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/product/downloadMenu',
        isJSon: true,
        responseType: 'blob',
    },
    
    


    sysUserShopRelationDel: {
        method: 'post',
        url: `${httpUrl}/sysUserShopRelation/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserShopRelation/delById',
    },
    sysUserShopRelationSave: {
        method: 'post',
        url: `${httpUrl}/sysUserShopRelation/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserShopRelation/save',
    },
    sysUserShopRelationQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysUserShopRelation/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserShopRelation/queryPage',
    },
    sysUserShopRelationFindById: {
        method: 'get',
        url: `${httpUrl}/sysUserShopRelation/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserShopRelation/findById',
    },
    sysUserShopRelationAllList: {
        method: 'get',
        url: `${httpUrl}/sysUserShopRelation/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysUserShopRelation/allList',
    },
    bmsCmdRecordDel: {
        method: 'post',
        url: `${httpUrl}/bmsCmdRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsCmdRecord/delById',
    },
    bmsCmdRecordSave: {
        method: 'post',
        url: `${httpUrl}/bmsCmdRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsCmdRecord/save',
    },
    bmsCmdPublish: {
        method: 'post',
        url: `${httpUrl}/mqtt/publish`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsCmdRecord/save',
    },

    batchUpgrade: {
        method: 'post',
        url: `${httpUrl}/mqtt/batchUpgrade`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsCmdRecord/save',
    },
    
    bmsCmdRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/bmsCmdRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsCmdRecord/queryPage',
    },
    bmsCmdRecordFindById: {
        method: 'get',
        url: `${httpUrl}/bmsCmdRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsCmdRecord/findById',
    },
    bmsCmdRecordAllList: {
        method: 'get',
        url: `${httpUrl}/bmsCmdRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsCmdRecord/allList',
    },
    printerBrandDel: {
        method: 'post',
        url: `${httpUrl}/printerBrand/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/printerBrand/delById',
    },
    printerBrandSave: {
        method: 'post',
        url: `${httpUrl}/printerBrand/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/printerBrand/save',
    },
    printerBrandQueryPage: {
        method: 'post',
        url: `${httpUrl}/printerBrand/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/printerBrand/queryPage',
    },
    printerBrandFindById: {
        method: 'get',
        url: `${httpUrl}/printerBrand/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/printerBrand/findById',
    },
    printerBrandAllList: {
        method: 'get',
        url: `${httpUrl}/printerBrand/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/printerBrand/allList',
    },
    htmlPageTemplateDel: {
        method: 'post',
        url: `${httpUrl}/htmlPageTemplate/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/htmlPageTemplate/delById',
    },
    htmlPageTemplateSave: {
        method: 'post',
        url: `${httpUrl}/htmlPageTemplate/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/htmlPageTemplate/save',
    },
    htmlPageTemplateQueryPage: {
        method: 'post',
        url: `${httpUrl}/htmlPageTemplate/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/htmlPageTemplate/queryPage',
    },
    htmlPageTemplateFindById: {
        method: 'get',
        url: `${httpUrl}/htmlPageTemplate/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/htmlPageTemplate/findById',
    },
    htmlPageTemplateAllList: {
        method: 'get',
        url: `${httpUrl}/htmlPageTemplate/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/htmlPageTemplate/allList',
    },

    generateCodeConfigDel: {
        method: 'post',
        url: `${httpUrl}/generateCodeConfig/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/generateCodeConfig/delById',
    },
    generateCodeConfigSave: {
        method: 'post',
        url: `${httpUrl}/generateCodeConfig/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/generateCodeConfig/save',
    },
    generateCodeConfigQueryPage: {
        method: 'post',
        url: `${httpUrl}/generateCodeConfig/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/generateCodeConfig/queryPage',
    },
    generateCodeConfigFindById: {
        method: 'get',
        url: `${httpUrl}/generateCodeConfig/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/generateCodeConfig/findById',
    },
    generateCodeConfigAllList: {
        method: 'get',
        url: `${httpUrl}/generateCodeConfig/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/generateCodeConfig/allList',
    },
    sysNotepadDel: {
        method: 'post',
        url: `${httpUrl}/sysNotepad/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysNotepad/delById',
    },
    sysNotepadSave: {
        method: 'post',
        url: `${httpUrl}/sysNotepad/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysNotepad/save',
    },
    sysNotepadQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysNotepad/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysNotepad/queryPage',
    },
    sysNotepadFindById: {
        method: 'get',
        url: `${httpUrl}/sysNotepad/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysNotepad/findById',
    },
    sysNotepadAllList: {
        method: 'get',
        url: `${httpUrl}/sysNotepad/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysNotepad/allList',
    },
    dynamicH5PageLinkDel: {
        method: 'post',
        url: `${httpUrl}/dynamicH5PageLink/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dynamicH5PageLink/delById',
    },
    dynamicH5PageLinkSave: {
        method: 'post',
        url: `${httpUrl}/dynamicH5PageLink/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dynamicH5PageLink/save',
    },
    dynamicH5PageLinkQueryPage: {
        method: 'post',
        url: `${httpUrl}/dynamicH5PageLink/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dynamicH5PageLink/queryPage',
    },
    dynamicH5PageLinkFindById: {
        method: 'get',
        url: `${httpUrl}/dynamicH5PageLink/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dynamicH5PageLink/findById',
    },
    dynamicH5PageLinkAllList: {
        method: 'get',
        url: `${httpUrl}/dynamicH5PageLink/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/dynamicH5PageLink/allList',
    },
    sysDomainNameConfigDel: {
        method: 'post',
        url: `${httpUrl}/sysDomainNameConfig/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDomainNameConfig/delById',
    },
    sysDomainNameConfigSave: {
        method: 'post',
        url: `${httpUrl}/sysDomainNameConfig/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDomainNameConfig/save',
    },
    sysDomainNameConfigQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysDomainNameConfig/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDomainNameConfig/queryPage',
    },
    sysDomainNameConfigFindById: {
        method: 'get',
        url: `${httpUrl}/sysDomainNameConfig/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDomainNameConfig/findById',
    },
    sysDomainNameConfigAllList: {
        method: 'get',
        url: `${httpUrl}/sysDomainNameConfig/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDomainNameConfig/allList',
    },
    huaruiLimaQrCodeDel: {
        method: 'post',
        url: `${httpUrl}/huaruiLimaQrCode/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiLimaQrCode/delById',
    },
    huaruiLimaQrCodeSave: {
        method: 'post',
        url: `${httpUrl}/huaruiLimaQrCode/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiLimaQrCode/save',
    },
    huaruiLimaQrCodeQueryPage: {
        method: 'post',
        url: `${httpUrl}/huaruiLimaQrCode/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiLimaQrCode/queryPage',
    },
    huaruiLimaQrCodeFindById: {
        method: 'get',
        url: `${httpUrl}/huaruiLimaQrCode/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiLimaQrCode/findById',
    },
    huaruiLimaQrCodeAllList: {
        method: 'get',
        url: `${httpUrl}/huaruiLimaQrCode/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiLimaQrCode/allList',
    },
    deviceGpsInfoDel: {
        method: 'post',
        url: `${httpUrl}/deviceGpsInfo/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceGpsInfo/delById',
    },
    deviceGpsInfoSave: {
        method: 'post',
        url: `${httpUrl}/deviceGpsInfo/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceGpsInfo/save',
    },
    deviceGpsInfoQueryPage: {
        method: 'post',
        url: `${httpUrl}/deviceGpsInfo/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceGpsInfo/queryPage',
    },
    deviceGpsInfoFindById: {
        method: 'get',
        url: `${httpUrl}/deviceGpsInfo/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceGpsInfo/findById',
    },
    deviceGpsInfoAllList: {
        method: 'get',
        url: `${httpUrl}/deviceGpsInfo/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceGpsInfo/allList',
    },
    sysDictDel: {
        method: 'post',
        url: `${httpUrl}/sysDict/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDict/delById',
    },
    sysDictSave: {
        method: 'post',
        url: `${httpUrl}/sysDict/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDict/save',
    },
    sysDictQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysDict/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDict/queryPage',
    },
    sysDictFindById: {
        method: 'get',
        url: `${httpUrl}/sysDict/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDict/findById',
    },
    sysDictAllList: {
        method: 'get',
        url: `${httpUrl}/sysDict/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDict/allList',
    },
    sysDictItemDel: {
        method: 'post',
        url: `${httpUrl}/sysDictItem/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDictItem/delById',
    },
    sysDictItemSave: {
        method: 'post',
        url: `${httpUrl}/sysDictItem/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDictItem/save',
    },
    sysDictItemQueryPage: {
        method: 'post',
        url: `${httpUrl}/sysDictItem/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDictItem/queryPage',
    },
    sysDictItemFindById: {
        method: 'get',
        url: `${httpUrl}/sysDictItem/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDictItem/findById',
    },
    sysDictItemAllList: {
        method: 'get',
        url: `${httpUrl}/sysDictItem/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDictItem/allList',
    },
    getDictItem: {
        method: 'get',
        url: `${httpUrl}/sysDict/getDictItem`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/sysDictItem/allList',
    },
    
    deviceDel: {
        method: 'post',
        url: `${httpUrl}/device/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/delById',
    },
    deviceQueryPage: {
        method: 'post',
        url: `${httpUrl}/device/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/queryPage',
    },
    deviceFindById: {
        method: 'get',
        url: `${httpUrl}/device/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/findById',
    },
    deviceAllList: {
        method: 'get',
        url: `${httpUrl}/device/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/device/allList',
    },
    deviceFieldDel: {
        method: 'post',
        url: `${httpUrl}/deviceField/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceField/delById',
    },
    deviceFieldSave: {
        method: 'post',
        url: `${httpUrl}/deviceField/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceField/save',
    },
    deviceFieldQueryPage: {
        method: 'post',
        url: `${httpUrl}/deviceField/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceField/queryPage',
    },
    deviceFieldFindById: {
        method: 'get',
        url: `${httpUrl}/deviceField/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceField/findById',
    },
    deviceFieldAllList: {
        method: 'get',
        url: `${httpUrl}/deviceField/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceField/allList',
    },
    deviceOpenLockRecordDel: {
        method: 'post',
        url: `${httpUrl}/deviceOpenLockRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOpenLockRecord/delById',
    },
    deviceOpenLockRecordSave: {
        method: 'post',
        url: `${httpUrl}/deviceOpenLockRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOpenLockRecord/save',
    },
    deviceOpenLockRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/deviceOpenLockRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOpenLockRecord/queryPage',
    },
    deviceOpenLockRecordFindById: {
        method: 'get',
        url: `${httpUrl}/deviceOpenLockRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOpenLockRecord/findById',
    },
    deviceOpenLockRecordAllList: {
        method: 'get',
        url: `${httpUrl}/deviceOpenLockRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/deviceOpenLockRecord/allList',
    },
    employeesDel: {
        method: 'post',
        url: `${httpUrl}/employees/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employees/delById',
    },

    employeeDataStatisticsCount:{
        method: 'get',
        url: `${httpUrl}/employee/getDataStatisticsCount`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employee/getDataStatisticsCount',
    },

    employeeEducationCount:{
        method: 'get',
        url: `${httpUrl}/employee/educationCount`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employee/getDataStatisticsCount',
    },
    
    employeesSave: {
        method: 'post',
        url: `${httpUrl}/employees/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employees/save',
    },
    employeesQueryPage: {
        method: 'post',
        url: `${httpUrl}/employees/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employees/queryPage',
    },
    completeTableOrder: {
        method: 'post',
        url: `${httpUrl}/shopTable/completeTableOrder`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employees/queryPage',
    },

    
    employeesFindById: {
        method: 'get',
        url: `${httpUrl}/employees/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employees/findById',
    },
    employeesAllList: {
        method: 'get',
        url: `${httpUrl}/employees/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employees/allList',
    },
    employeesExcelExport: {
        method: 'post',
        url: `${httpUrl}/employees/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employees/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    departmentDel: {
        method: 'post',
        url: `${httpUrl}/department/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/department/delById',
    },
    departmentSave: {
        method: 'post',
        url: `${httpUrl}/department/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/department/save',
    },
    departmentQueryPage: {
        method: 'post',
        url: `${httpUrl}/department/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/department/queryPage',
    },
    departmentFindById: {
        method: 'get',
        url: `${httpUrl}/department/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/department/findById',
    },
    departmentExcelExport: {
        method: 'post',
        url: `${httpUrl}/department/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/department/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    departmentAllList: {
        method: 'get',
        url: `${httpUrl}/department/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/department/allList',
    },
    positionsDel: {
        method: 'post',
        url: `${httpUrl}/positions/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/positions/delById',
    },
    positionsSave: {
        method: 'post',
        url: `${httpUrl}/positions/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/positions/save',
    },
    positionsQueryPage: {
        method: 'post',
        url: `${httpUrl}/positions/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/positions/queryPage',
    },
    positionsFindById: {
        method: 'get',
        url: `${httpUrl}/positions/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/positions/findById',
    },
    positionsExcelExport: {
        method: 'post',
        url: `${httpUrl}/positions/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/positions/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    positionsAllList: {
        method: 'get',
        url: `${httpUrl}/positions/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/positions/allList',
    },
    employeeTransferDel: {
        method: 'post',
        url: `${httpUrl}/employeeTransfer/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeTransfer/delById',
    },
    employeeTransferSave: {
        method: 'post',
        url: `${httpUrl}/employeeTransfer/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeTransfer/save',
    },
    employeeTransferQueryPage: {
        method: 'post',
        url: `${httpUrl}/employeeTransfer/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeTransfer/queryPage',
    },
    employeeTransferFindById: {
        method: 'get',
        url: `${httpUrl}/employeeTransfer/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeTransfer/findById',
    },
    employeeTransferExcelExport: {
        method: 'post',
        url: `${httpUrl}/employeeTransfer/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeTransfer/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    employeeTransferAllList: {
        method: 'get',
        url: `${httpUrl}/employeeTransfer/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeTransfer/allList',
    },
    employeeSalaryAdjustmentDel: {
        method: 'post',
        url: `${httpUrl}/employeeSalaryAdjustment/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalaryAdjustment/delById',
    },
    employeeSalaryAdjustmentSave: {
        method: 'post',
        url: `${httpUrl}/employeeSalaryAdjustment/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalaryAdjustment/save',
    },
    employeeSalaryAdjustmentQueryPage: {
        method: 'post',
        url: `${httpUrl}/employeeSalaryAdjustment/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalaryAdjustment/queryPage',
    },
    employeeSalaryAdjustmentFindById: {
        method: 'get',
        url: `${httpUrl}/employeeSalaryAdjustment/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalaryAdjustment/findById',
    },
    employeeSalaryAdjustmentExcelExport: {
        method: 'post',
        url: `${httpUrl}/employeeSalaryAdjustment/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalaryAdjustment/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    employeeSalaryAdjustmentAllList: {
        method: 'get',
        url: `${httpUrl}/employeeSalaryAdjustment/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalaryAdjustment/allList',
    },
    employeeSalaryDel: {
        method: 'post',
        url: `${httpUrl}/employeeSalary/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalary/delById',
    },
    employeeSalarySave: {
        method: 'post',
        url: `${httpUrl}/employeeSalary/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalary/save',
    },
    employeeSalaryQueryPage: {
        method: 'post',
        url: `${httpUrl}/employeeSalary/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalary/queryPage',
    },
    employeeSalaryFindById: {
        method: 'get',
        url: `${httpUrl}/employeeSalary/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalary/findById',
    },
    employeeSalaryExcelExport: {
        method: 'post',
        url: `${httpUrl}/employeeSalary/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalary/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    employeeSalaryAllList: {
        method: 'get',
        url: `${httpUrl}/employeeSalary/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeSalary/allList',
    },
    employeeResignationDel: {
        method: 'post',
        url: `${httpUrl}/employeeResignation/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeResignation/delById',
    },
    employeeResignationSave: {
        method: 'post',
        url: `${httpUrl}/employeeResignation/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeResignation/save',
    },
    employeeResignationQueryPage: {
        method: 'post',
        url: `${httpUrl}/employeeResignation/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeResignation/queryPage',
    },
    employeeResignationFindById: {
        method: 'get',
        url: `${httpUrl}/employeeResignation/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeResignation/findById',
    },
    employeeResignationExcelExport: {
        method: 'post',
        url: `${httpUrl}/employeeResignation/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeResignation/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    employeeResignationAllList: {
        method: 'get',
        url: `${httpUrl}/employeeResignation/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeResignation/allList',
    },
    employeeDel: {
        method: 'post',
        url: `${httpUrl}/employee/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employee/delById',
    },
    employeeSave: {
        method: 'post',
        url: `${httpUrl}/employee/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employee/save',
    },
    employeeQueryPage: {
        method: 'post',
        url: `${httpUrl}/employee/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employee/queryPage',
    },
    employeeFindById: {
        method: 'get',
        url: `${httpUrl}/employee/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employee/findById',
    },
    employeeExcelExport: {
        method: 'post',
        url: `${httpUrl}/employee/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employee/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    employeeAllList: {
        method: 'get',
        url: `${httpUrl}/employee/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employee/allList',
    },
    employeeAttendanceRecordDel: {
        method: 'post',
        url: `${httpUrl}/employeeAttendanceRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeAttendanceRecord/delById',
    },
    employeeAttendanceRecordSave: {
        method: 'post',
        url: `${httpUrl}/employeeAttendanceRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeAttendanceRecord/save',
    },
    employeeAttendanceRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/employeeAttendanceRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeAttendanceRecord/queryPage',
    },
    employeeAttendanceRecordFindById: {
        method: 'get',
        url: `${httpUrl}/employeeAttendanceRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeAttendanceRecord/findById',
    },
    employeeAttendanceRecordExcelExport: {
        method: 'post',
        url: `${httpUrl}/employeeAttendanceRecord/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeAttendanceRecord/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    employeeAttendanceRecordAllList: {
        method: 'get',
        url: `${httpUrl}/employeeAttendanceRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/employeeAttendanceRecord/allList',
    },
    bmsBatteryPackInfoExcelExport: {
        method: 'post',
        url: `${httpUrl}/bmsBatteryPackInfo/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsBatteryPackInfo/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    appOnloadLogsDel: {
        method: 'post',
        url: `${httpUrl}/appOnloadLogs/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appOnloadLogs/delById',
    },
    appOnloadLogsSave: {
        method: 'post',
        url: `${httpUrl}/appOnloadLogs/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appOnloadLogs/save',
    },
    appOnloadLogsQueryPage: {
        method: 'post',
        url: `${httpUrl}/appOnloadLogs/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appOnloadLogs/queryPage',
    },
    appOnloadLogsFindById: {
        method: 'get',
        url: `${httpUrl}/appOnloadLogs/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appOnloadLogs/findById',
    },
    appOnloadLogsExcelExport: {
        method: 'post',
        url: `${httpUrl}/appOnloadLogs/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appOnloadLogs/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    appOnloadLogsAllList: {
        method: 'get',
        url: `${httpUrl}/appOnloadLogs/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/appOnloadLogs/allList',
    },
    membershipDel: {
        method: 'post',
        url: `${httpUrl}/membership/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/membership/delById',
    },
    membershipSave: {
        method: 'post',
        url: `${httpUrl}/membership/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/membership/save',
    },
    membershipQueryPage: {
        method: 'post',
        url: `${httpUrl}/membership/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/membership/queryPage',
    },
    membershipFindById: {
        method: 'get',
        url: `${httpUrl}/membership/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/membership/findById',
    },
    membershipExcelExport: {
        method: 'post',
        url: `${httpUrl}/membership/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/membership/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    membershipAllList: {
        method: 'get',
        url: `${httpUrl}/membership/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/membership/allList',
    },
    shopTableItemDel: {
        method: 'post',
        url: `${httpUrl}/shopTableItem/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTableItem/delById',
    },
    shopTableItemSave: {
        method: 'post',
        url: `${httpUrl}/shopTableItem/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTableItem/save',
    },
    shopTableItemQueryPage: {
        method: 'post',
        url: `${httpUrl}/shopTableItem/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTableItem/queryPage',
    },
    shopTableItemFindById: {
        method: 'get',
        url: `${httpUrl}/shopTableItem/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTableItem/findById',
    },
    shopTableItemExcelExport: {
        method: 'post',
        url: `${httpUrl}/shopTableItem/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTableItem/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    shopTableItemAllList: {
        method: 'get',
        url: `${httpUrl}/shopTableItem/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopTableItem/allList',
    },
    bmsHexLogDel: {
        method: 'post',
        url: `${httpUrl}/bmsHexLog/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsHexLog/delById',
    },


    miniProgramCategoryList: {
        method: 'post',
        url: `${httpUrl}/miniprogramRegister/getCategoriesList`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsHexLog/delById',
    },

    bmsHexLogSave: {
        method: 'post',
        url: `${httpUrl}/bmsHexLog/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsHexLog/save',
    },
    bmsHexLogQueryPage: {
        method: 'post',
        url: `${httpUrl}/bmsHexLog/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsHexLog/queryPage',
    },
    bmsHexLogFindById: {
        method: 'get',
        url: `${httpUrl}/bmsHexLog/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsHexLog/findById',
    },
    bmsHexLogExcelExport: {
        method: 'post',
        url: `${httpUrl}/bmsHexLog/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsHexLog/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    bmsHexLogAllList: {
        method: 'get',
        url: `${httpUrl}/bmsHexLog/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/bmsHexLog/allList',
    },
    miniprogramRegisterDel: {
        method: 'post',
        url: `${httpUrl}/miniprogramRegister/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/miniprogramRegister/delById',
    },
    miniprogramSetInfo: {
        method: 'post',
        url: `${httpUrl}/miniprogramRegister/setInfo`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/miniprogramRegister/delById',
    },
    miniprogramRegisterSave: {
        method: 'post',
        url: `${httpUrl}/miniprogramRegister/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/miniprogramRegister/save',
    },
    miniprogramRegisterQueryPage: {
        method: 'post',
        url: `${httpUrl}/miniprogramRegister/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/miniprogramRegister/queryPage',
    },
    miniprogramRegisterFindById: {
        method: 'get',
        url: `${httpUrl}/miniprogramRegister/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/miniprogramRegister/findById',
    },
    miniprogramRegisterExcelExport: {
        method: 'post',
        url: `${httpUrl}/miniprogramRegister/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/miniprogramRegister/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    miniprogramRegisterAllList: {
        method: 'get',
        url: `${httpUrl}/miniprogramRegister/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/miniprogramRegister/allList',
    },
    componentAccessTokensDel: {
        method: 'post',
        url: `${httpUrl}/componentAccessTokens/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/componentAccessTokens/delById',
    },
    componentAccessTokensSave: {
        method: 'post',
        url: `${httpUrl}/componentAccessTokens/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/componentAccessTokens/save',
    },
    componentAccessTokensQueryPage: {
        method: 'post',
        url: `${httpUrl}/componentAccessTokens/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/componentAccessTokens/queryPage',
    },
    componentAccessTokensFindById: {
        method: 'get',
        url: `${httpUrl}/componentAccessTokens/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/componentAccessTokens/findById',
    },
    componentAccessTokensExcelExport: {
        method: 'post',
        url: `${httpUrl}/componentAccessTokens/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/componentAccessTokens/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    componentAccessTokensAllList: {
        method: 'get',
        url: `${httpUrl}/componentAccessTokens/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/componentAccessTokens/allList',
    },
    suggestionReportingDel: {
        method: 'post',
        url: `${httpUrl}/suggestionReporting/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/suggestionReporting/delById',
    },
    suggestionReportingSave: {
        method: 'post',
        url: `${httpUrl}/suggestionReporting/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/suggestionReporting/save',
    },
    suggestionReportingQueryPage: {
        method: 'post',
        url: `${httpUrl}/suggestionReporting/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/suggestionReporting/queryPage',
    },
    suggestionReportingFindById: {
        method: 'get',
        url: `${httpUrl}/suggestionReporting/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/suggestionReporting/findById',
    },
    suggestionReportingExcelExport: {
        method: 'post',
        url: `${httpUrl}/suggestionReporting/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/suggestionReporting/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    suggestionReportingAllList: {
        method: 'get',
        url: `${httpUrl}/suggestionReporting/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/suggestionReporting/allList',
    },
    userTeamsGroupRelationDel: {
        method: 'post',
        url: `${httpUrl}/userTeamsGroupRelation/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userTeamsGroupRelation/delById',
    },
    userTeamsGroupRelationSave: {
        method: 'post',
        url: `${httpUrl}/userTeamsGroupRelation/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userTeamsGroupRelation/save',
    },
    userTeamsGroupRelationQueryPage: {
        method: 'post',
        url: `${httpUrl}/userTeamsGroupRelation/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userTeamsGroupRelation/queryPage',
    },
    userTeamsGroupRelationFindById: {
        method: 'get',
        url: `${httpUrl}/userTeamsGroupRelation/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userTeamsGroupRelation/findById',
    },
    userTeamsGroupRelationExcelExport: {
        method: 'post',
        url: `${httpUrl}/userTeamsGroupRelation/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userTeamsGroupRelation/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    userTeamsGroupRelationAllList: {
        method: 'get',
        url: `${httpUrl}/userTeamsGroupRelation/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userTeamsGroupRelation/allList',
    },
    teamsGroupDel: {
        method: 'post',
        url: `${httpUrl}/teamsGroup/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/teamsGroup/delById',
    },
    teamsGroupSave: {
        method: 'post',
        url: `${httpUrl}/teamsGroup/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/teamsGroup/save',
    },
    teamsGroupQueryPage: {
        method: 'post',
        url: `${httpUrl}/teamsGroup/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/teamsGroup/queryPage',
    },
    teamsGroupFindById: {
        method: 'get',
        url: `${httpUrl}/teamsGroup/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/teamsGroup/findById',
    },
    teamsGroupExcelExport: {
        method: 'post',
        url: `${httpUrl}/teamsGroup/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/teamsGroup/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    teamsGroupAllList: {
        method: 'get',
        url: `${httpUrl}/teamsGroup/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/teamsGroup/allList',
    },
    mealReportingRecordDel: {
        method: 'post',
        url: `${httpUrl}/mealReportingRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingRecord/delById',
    },
    mealReportingRecordSave: {
        method: 'post',
        url: `${httpUrl}/mealReportingRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingRecord/save',
    },
    mealReportingRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/mealReportingRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingRecord/queryPage',
    },
    mealReportingRecordFindById: {
        method: 'get',
        url: `${httpUrl}/mealReportingRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingRecord/findById',
    },
    mealReportingRecordExcelExport: {
        method: 'post',
        url: `${httpUrl}/mealReportingRecord/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingRecord/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    mealReportingRecordAllList: {
        method: 'get',
        url: `${httpUrl}/mealReportingRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingRecord/allList',
    },
    mealReportingQrDel: {
        method: 'post',
        url: `${httpUrl}/mealReportingQr/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingQr/delById',
    },
    mealReportingQrSave: {
        method: 'post',
        url: `${httpUrl}/mealReportingQr/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingQr/save',
    },
    mealReportingQrQueryPage: {
        method: 'post',
        url: `${httpUrl}/mealReportingQr/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingQr/queryPage',
    },
    mealReportingQrFindById: {
        method: 'get',
        url: `${httpUrl}/mealReportingQr/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingQr/findById',
    },
    mealReportingQrExcelExport: {
        method: 'post',
        url: `${httpUrl}/mealReportingQr/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingQr/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    mealReportingQrAllList: {
        method: 'get',
        url: `${httpUrl}/mealReportingQr/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/mealReportingQr/allList',
    },
    systemQuestionTemplatesDel: {
        method: 'post',
        url: `${httpUrl}/systemQuestionTemplates/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/systemQuestionTemplates/delById',
    },
    systemQuestionTemplatesSave: {
        method: 'post',
        url: `${httpUrl}/systemQuestionTemplates/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/systemQuestionTemplates/save',
    },
    systemQuestionTemplatesQueryPage: {
        method: 'post',
        url: `${httpUrl}/systemQuestionTemplates/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/systemQuestionTemplates/queryPage',
    },
    systemQuestionTemplatesFindById: {
        method: 'get',
        url: `${httpUrl}/systemQuestionTemplates/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/systemQuestionTemplates/findById',
    },
    systemQuestionTemplatesExcelExport: {
        method: 'post',
        url: `${httpUrl}/systemQuestionTemplates/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/systemQuestionTemplates/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    systemQuestionTemplatesAllList: {
        method: 'get',
        url: `${httpUrl}/systemQuestionTemplates/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/systemQuestionTemplates/allList',
    },
    huaruiImgToBinRecordDel: {
        method: 'post',
        url: `${httpUrl}/huaruiImgToBinRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiImgToBinRecord/delById',
    },
    huaruiImgToBinRecordSave: {
        method: 'post',
        url: `${httpUrl}/huaruiImgToBinRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiImgToBinRecord/save',
    },
    huaruiImgToBinRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/huaruiImgToBinRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiImgToBinRecord/queryPage',
    },
    huaruiImgToBinRecordFindById: {
        method: 'get',
        url: `${httpUrl}/huaruiImgToBinRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiImgToBinRecord/findById',
    },
    huaruiImgToBinRecordExcelExport: {
        method: 'post',
        url: `${httpUrl}/huaruiImgToBinRecord/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiImgToBinRecord/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    huaruiImgToBinRecordAllList: {
        method: 'get',
        url: `${httpUrl}/huaruiImgToBinRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/huaruiImgToBinRecord/allList',
    },
    userChatRecordDel: {
        method: 'post',
        url: `${httpUrl}/userChatRecord/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userChatRecord/delById',
    },
    userChatRecordSave: {
        method: 'post',
        url: `${httpUrl}/userChatRecord/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userChatRecord/save',
    },
    userChatRecordQueryPage: {
        method: 'post',
        url: `${httpUrl}/userChatRecord/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userChatRecord/queryPage',
    },
    userChatRecordFindById: {
        method: 'get',
        url: `${httpUrl}/userChatRecord/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userChatRecord/findById',
    },
    userChatRecordExcelExport: {
        method: 'post',
        url: `${httpUrl}/userChatRecord/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userChatRecord/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    userChatRecordAllList: {
        method: 'get',
        url: `${httpUrl}/userChatRecord/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userChatRecord/allList',
    },
    doctorPatientConversationDel: {
        method: 'post',
        url: `${httpUrl}/doctorPatientConversation/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/doctorPatientConversation/delById',
    },
    doctorPatientConversationSave: {
        method: 'post',
        url: `${httpUrl}/doctorPatientConversation/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/doctorPatientConversation/save',
    },
    doctorPatientConversationQueryPage: {
        method: 'post',
        url: `${httpUrl}/doctorPatientConversation/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/doctorPatientConversation/queryPage',
    },
    doctorPatientConversationFindById: {
        method: 'get',
        url: `${httpUrl}/doctorPatientConversation/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/doctorPatientConversation/findById',
    },
    doctorPatientConversationExcelExport: {
        method: 'post',
        url: `${httpUrl}/doctorPatientConversation/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/doctorPatientConversation/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    doctorPatientConversationAllList: {
        method: 'get',
        url: `${httpUrl}/doctorPatientConversation/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/doctorPatientConversation/allList',
    },
    chataiSessionDel: {
        method: 'post',
        url: `${httpUrl}/chataiSession/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/chataiSession/delById',
    },
    chataiSessionSave: {
        method: 'post',
        url: `${httpUrl}/chataiSession/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/chataiSession/save',
    },
    chataiSessionQueryPage: {
        method: 'post',
        url: `${httpUrl}/chataiSession/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/chataiSession/queryPage',
    },
    chataiSessionFindById: {
        method: 'get',
        url: `${httpUrl}/chataiSession/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/chataiSession/findById',
    },
    chataiSessionExcelExport: {
        method: 'post',
        url: `${httpUrl}/chataiSession/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/chataiSession/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    chataiSessionAllList: {
        method: 'get',
        url: `${httpUrl}/chataiSession/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/chataiSession/allList',
    },
    commandConfigDel: {
        method: 'post',
        url: `${httpUrl}/commandConfig/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/commandConfig/delById',
    },
    commandConfigSave: {
        method: 'post',
        url: `${httpUrl}/commandConfig/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/commandConfig/save',
    },
    commandConfigQueryPage: {
        method: 'post',
        url: `${httpUrl}/commandConfig/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/commandConfig/queryPage',
    },
    commandConfigFindById: {
        method: 'get',
        url: `${httpUrl}/commandConfig/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/commandConfig/findById',
    },
    commandConfigExcelExport: {
        method: 'post',
        url: `${httpUrl}/commandConfig/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/commandConfig/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    commandConfigAllList: {
        method: 'get',
        url: `${httpUrl}/commandConfig/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/commandConfig/allList',
    },

    fileMetadataDel: {
        method: 'post',
        url: `${httpUrl}/fileMetadata/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileMetadata/delById',
    },
    fileMetadataSave: {
        method: 'post',
        url: `${httpUrl}/fileMetadata/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileMetadata/save',
    },
    fileMetadataQueryPage: {
        method: 'post',
        url: `${httpUrl}/fileMetadata/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileMetadata/queryPage',
    },
    fileMetadataFindById: {
        method: 'get',
        url: `${httpUrl}/fileMetadata/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileMetadata/findById',
    },
    fileMetadataExcelExport: {
        method: 'post',
        url: `${httpUrl}/fileMetadata/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileMetadata/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    fileMetadataAllList: {
        method: 'get',
        url: `${httpUrl}/fileMetadata/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/fileMetadata/allList',
    },

    aiModelConfigDel: {
        method: 'post',
        url: `${httpUrl}/aiModelConfig/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/aiModelConfig/delById',
    },
    aiModelConfigSave: {
        method: 'post',
        url: `${httpUrl}/aiModelConfig/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/aiModelConfig/save',
    },
    aiModelConfigQueryPage: {
        method: 'post',
        url: `${httpUrl}/aiModelConfig/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/aiModelConfig/queryPage',
    },
    aiModelConfigFindById: {
        method: 'get',
        url: `${httpUrl}/aiModelConfig/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/aiModelConfig/findById',
    },
    aiModelConfigExcelExport: {
        method: 'post',
        url: `${httpUrl}/aiModelConfig/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/aiModelConfig/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    aiModelConfigAllList: {
        method: 'get',
        url: `${httpUrl}/aiModelConfig/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/aiModelConfig/allList',
    },
    
    workstationDel: {
        method: 'post',
        url: `${httpUrl}/workstation/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/workstation/delById',
    },
    workstationSave: {
        method: 'post',
        url: `${httpUrl}/workstation/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/workstation/save',
    },
    workstationQueryPage: {
        method: 'post',
        url: `${httpUrl}/workstation/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/workstation/queryPage',
    },
    workstationFindById: {
        method: 'get',
        url: `${httpUrl}/workstation/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/workstation/findById',
    },
    workstationExcelExport: {
        method: 'post',
        url: `${httpUrl}/workstation/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/workstation/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    workstationAllList: {
        method: 'get',
        url: `${httpUrl}/workstation/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/workstation/allList',
    },
    productionLineDel: {
        method: 'post',
        url: `${httpUrl}/productionLine/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionLine/delById',
    },
    productionLineSave: {
        method: 'post',
        url: `${httpUrl}/productionLine/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionLine/save',
    },
    productionLineQueryPage: {
        method: 'post',
        url: `${httpUrl}/productionLine/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionLine/queryPage',
    },
    productionLineFindById: {
        method: 'get',
        url: `${httpUrl}/productionLine/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionLine/findById',
    },
    productionLineExcelExport: {
        method: 'post',
        url: `${httpUrl}/productionLine/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionLine/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    productionLineAllList: {
        method: 'get',
        url: `${httpUrl}/productionLine/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionLine/allList',
    },
    purchaseOrderDel: {
        method: 'post',
        url: `${httpUrl}/purchaseOrder/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrder/delById',
    },
    purchaseOrderSave: {
        method: 'post',
        url: `${httpUrl}/purchaseOrder/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrder/save',
    },
    purchaseOrderQueryPage: {
        method: 'post',
        url: `${httpUrl}/purchaseOrder/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrder/queryPage',
    },
    purchaseOrderFindById: {
        method: 'get',
        url: `${httpUrl}/purchaseOrder/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrder/findById',
    },
    purchaseOrderExcelExport: {
        method: 'post',
        url: `${httpUrl}/purchaseOrder/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrder/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    purchaseOrderAllList: {
        method: 'get',
        url: `${httpUrl}/purchaseOrder/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrder/allList',
    },
    purchaseOrderItemDel: {
        method: 'post',
        url: `${httpUrl}/purchaseOrderItem/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrderItem/delById',
    },
    purchaseOrderItemSave: {
        method: 'post',
        url: `${httpUrl}/purchaseOrderItem/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrderItem/save',
    },
    purchaseOrderItemQueryPage: {
        method: 'post',
        url: `${httpUrl}/purchaseOrderItem/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrderItem/queryPage',
    },
    purchaseOrderItemFindById: {
        method: 'get',
        url: `${httpUrl}/purchaseOrderItem/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrderItem/findById',
    },
    purchaseOrderItemExcelExport: {
        method: 'post',
        url: `${httpUrl}/purchaseOrderItem/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrderItem/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    purchaseOrderItemAllList: {
        method: 'get',
        url: `${httpUrl}/purchaseOrderItem/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/purchaseOrderItem/allList',
    },
    rawMaterialDel: {
        method: 'post',
        url: `${httpUrl}/rawMaterial/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rawMaterial/delById',
    },
    rawMaterialSave: {
        method: 'post',
        url: `${httpUrl}/rawMaterial/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rawMaterial/save',
    },
    rawMaterialQueryPage: {
        method: 'post',
        url: `${httpUrl}/rawMaterial/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rawMaterial/queryPage',
    },
    rawMaterialFindById: {
        method: 'get',
        url: `${httpUrl}/rawMaterial/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rawMaterial/findById',
    },
    rawMaterialExcelExport: {
        method: 'post',
        url: `${httpUrl}/rawMaterial/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rawMaterial/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    rawMaterialAllList: {
        method: 'get',
        url: `${httpUrl}/rawMaterial/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/rawMaterial/allList',
    },
    shopRawMaterialDel: {
        method: 'post',
        url: `${httpUrl}/shopRawMaterial/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopRawMaterial/delById',
    },
    shopRawMaterialSave: {
        method: 'post',
        url: `${httpUrl}/shopRawMaterial/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopRawMaterial/save',
    },
    shopRawMaterialQueryPage: {
        method: 'post',
        url: `${httpUrl}/shopRawMaterial/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopRawMaterial/queryPage',
    },
    shopRawMaterialFindById: {
        method: 'get',
        url: `${httpUrl}/shopRawMaterial/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopRawMaterial/findById',
    },
    shopRawMaterialExcelExport: {
        method: 'post',
        url: `${httpUrl}/shopRawMaterial/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopRawMaterial/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    shopRawMaterialAllList: {
        method: 'get',
        url: `${httpUrl}/shopRawMaterial/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/shopRawMaterial/allList',
    },
    userEmployeeRelationDel: {
        method: 'post',
        url: `${httpUrl}/userEmployeeRelation/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userEmployeeRelation/delById',
    },
    userEmployeeRelationSave: {
        method: 'post',
        url: `${httpUrl}/userEmployeeRelation/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userEmployeeRelation/save',
    },
    userEmployeeRelationQueryPage: {
        method: 'post',
        url: `${httpUrl}/userEmployeeRelation/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userEmployeeRelation/queryPage',
    },
    userEmployeeRelationFindById: {
        method: 'get',
        url: `${httpUrl}/userEmployeeRelation/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userEmployeeRelation/findById',
    },
    userEmployeeRelationExcelExport: {
        method: 'post',
        url: `${httpUrl}/userEmployeeRelation/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userEmployeeRelation/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    userEmployeeRelationAllList: {
        method: 'get',
        url: `${httpUrl}/userEmployeeRelation/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/userEmployeeRelation/allList',
    },
    lineWorkstationDel: {
        method: 'post',
        url: `${httpUrl}/lineWorkstation/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/lineWorkstation/delById',
    },
    lineWorkstationSave: {
        method: 'post',
        url: `${httpUrl}/lineWorkstation/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/lineWorkstation/save',
    },
    lineWorkstationQueryPage: {
        method: 'post',
        url: `${httpUrl}/lineWorkstation/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/lineWorkstation/queryPage',
    },
    lineWorkstationFindById: {
        method: 'get',
        url: `${httpUrl}/lineWorkstation/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/lineWorkstation/findById',
    },
    lineWorkstationExcelExport: {
        method: 'post',
        url: `${httpUrl}/lineWorkstation/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/lineWorkstation/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    lineWorkstationAllList: {
        method: 'get',
        url: `${httpUrl}/lineWorkstation/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/lineWorkstation/allList',
    },
    productionPlanDel: {
        method: 'post',
        url: `${httpUrl}/productionPlan/delById`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionPlan/delById',
    },
    productionPlanSave: {
        method: 'post',
        url: `${httpUrl}/productionPlan/save`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionPlan/save',
    },
    productionPlanQueryPage: {
        method: 'post',
        url: `${httpUrl}/productionPlan/queryPage`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionPlan/queryPage',
    },
    productionPlanFindById: {
        method: 'get',
        url: `${httpUrl}/productionPlan/findById`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionPlan/findById',
    },
    productionPlanExcelExport: {
        method: 'post',
        url: `${httpUrl}/productionPlan/excelExport`,
        mockMethod: 'post',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionPlan/excelExport',
        isJSon: true,
        responseType: 'blob',
        isUrlRest:false,
    },
    productionPlanAllList: {
        method: 'get',
        url: `${httpUrl}/productionPlan/allList`,
        mockMethod: 'get',
        mockUrl: 'http://mockjs.docway.net/mock/1dutuUgqcF7/api/productionPlan/allList',
    },
};

export default globalServices;


// WEBPACK FOOTER //
// ./src/services/api.js